webpackJsonp([1],{

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditServiceTrackingDialog_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476a7edf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditServiceTrackingDialog_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditServiceTrackingDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476a7edf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditServiceTrackingDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notification__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_tracking__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__invoice__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error__ = __webpack_require__(479);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    service: __WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */],
    customer: __WEBPACK_IMPORTED_MODULE_4__customer__["a" /* default */],
    notification: __WEBPACK_IMPORTED_MODULE_5__notification__["a" /* default */],
    serviceTracking: __WEBPACK_IMPORTED_MODULE_6__service_tracking__["a" /* default */],
    invoice: __WEBPACK_IMPORTED_MODULE_7__invoice__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_8__error__["a" /* default */]
  },
  state: {
    changePassword: false,
    startLoading: false,
    loading: false,
    startDataLoading: false,
    dataLoading: false,
    showNotification: false,
    notificationMessage: {
      title: '',
      text: '',
      type: ''
    }
  },
  mutations: {
    setChangePassword: function setChangePassword(state, payload) {
      state.changePassword = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setStartLoading: function setStartLoading(state, payload) {
      state.startLoading = payload;
    },
    setDataLoading: function setDataLoading(state, payload) {
      state.dataLoading = payload;
    },
    setStartDataLoading: function setStartDataLoading(state, payload) {
      state.startDataLoading = payload;
    }
  },
  actions: {
    startLoading: function startLoading(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('setStartLoading', true);
      setTimeout(function () {
        if (state.startLoading === true) {
          commit('setLoading', true);
        }
      }, 1000);
    },
    stopLoading: function stopLoading(_ref2) {
      var commit = _ref2.commit;

      commit('setStartLoading', false);
      commit('setLoading', false);
    },
    startDataLoading: function startDataLoading(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('setStartDataLoading', true);
      setTimeout(function () {
        if (state.startDataLoading === true) {
          commit('setDataLoading', true);
        }
      }, 1000);
    },
    stopDataLoading: function stopDataLoading(_ref4) {
      var commit = _ref4.commit;

      commit('setStartDataLoading', false);
      commit('setDataLoading', false);
    }
  },
  getters: {
    changePassword: function changePassword(state) {
      return state.changePassword;
    },
    loading: function loading(state) {
      return state.loading;
    },
    dataLoading: function dataLoading(state) {
      return state.dataLoading;
    },
    startDataLoading: function startDataLoading(state) {
      return state.startDataLoading;
    }
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: null,
      items: [{ icon: 'timer', lable: 'Zeit erfassen', link: '/myTracking', allowedRoles: ['USER'] }, { icon: 'timer', lable: 'Genehmigte Zeiten', link: '/myApprovedTracking', allowedRoles: ['USER'] }, { icon: 'timer', lable: 'Zeiten genehmigen', link: '/allTracking', allowedRoles: ['ADMIN'] }, { icon: 'group', lable: 'Kunden', link: '/customers', allowedRoles: ['ADMIN'] }, { icon: 'work', lable: 'Dienstleistungen', link: '/services', allowedRoles: ['ADMIN'] }, { icon: 'person_add', lable: 'Mitarbeiter', link: '/usermgmt', allowedRoles: ['ADMIN'] }, { icon: 'receipt', lable: 'Abrechnungen', link: '/invoices', allowedRoles: ['ADMIN'] }]
    };
  },
  computed: {
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsAdmin: function userIsAdmin() {
      if (this.userIsAuthenticated) {
        return this.$store.getters.user.role.toUpperCase() === 'ADMIN';
      }
    },

    showNotification: {
      get: function get() {
        return this.$store.getters.showNotification;
      },
      set: function set(showNotification) {
        this.$store.dispatch('setShowNotification', showNotification);
      }
    },
    notificationMessage: function notificationMessage() {
      return this.$store.getters.notificationMessage;
    }
  },
  methods: {
    isAllowed: function isAllowed(roles) {
      if (this.$store.getters.user === null) return false;
      return roles.includes(this.$store.getters.user.role);
    },
    closeNotification: function closeNotification() {
      this.$store.commit('setShowNotification', false);
    },
    onLogout: function onLogout() {
      this.$store.dispatch('signUserOut').then(function () {
        return location.reload();
      });
    }
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewServiceTrackingDialog__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditServiceTrackingDialog__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeleteServiceTrackingConfirmDialog__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApproveServiceTrackingDialog__ = __webpack_require__(255);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyServiceTracking',
  components: {
    'new-tracking-dialog': __WEBPACK_IMPORTED_MODULE_0__NewServiceTrackingDialog__["a" /* default */],
    'edit-service-tracking-dialog': __WEBPACK_IMPORTED_MODULE_1__EditServiceTrackingDialog__["a" /* default */],
    'delete-service-tracking-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__DeleteServiceTrackingConfirmDialog__["a" /* default */],
    'approve-service-tracking-dialog': __WEBPACK_IMPORTED_MODULE_3__ApproveServiceTrackingDialog__["a" /* default */]
  },
  data: function data() {
    return {
      page: 0,
      size: 20,
      bottom: false,
      showNewServiceTrackingDialog: false,
      showEditServiceTrackingDialog: false,
      showDeleteServiceTrackingConfirmDialog: false,
      showApproveServiceTrackingDialog: false,
      selectedRecord: {
        id: null,
        customer: null,
        service: null,
        date: null,
        startTime: null,
        finishTime: null,
        approved: false
      }
    };
  },

  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.page++;
        this.loadMyServicesTrackings();
      }
    }
  },
  computed: {
    myTrackings: function myTrackings() {
      return this.$store.getters.myServiceTrackings;
    }
  },
  created: function created() {
    this.$store.dispatch('loadUserData', this.$store.getters.user);
    this.resetTrackings();
  },

  methods: {
    loadMyServicesTrackings: function loadMyServicesTrackings() {
      this.$store.dispatch('loadMyServicesTrackings', {
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    getDate: function getDate(millis) {
      var date = new Date(millis);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      return dd + '.' + mm + '.' + yyyy;
    },
    getTime: function getTime(millis) {
      var date = new Date(millis);
      var mn = date.getMinutes();
      var hr = date.getHours();

      if (mn < 10) {
        mn = '0' + mn;
      }

      if (hr < 10) {
        hr = '0' + hr;
      }

      return hr + ':' + mn;
    },
    getDay: function getDay(millis) {
      var ms = new Date(millis);
      var msPerDay = 86400000;
      var beginning = ms - ms % msPerDay;
      beginning += new Date().getTimezoneOffset() * 60 * 1000;
      return beginning;
    },
    openNewServiceTracking: function openNewServiceTracking() {
      this.showNewServiceTrackingDialog = true;
    },
    closeNewServiceTracking: function closeNewServiceTracking() {
      this.showNewServiceTrackingDialog = false;
    },
    openEditServiceTracking: function openEditServiceTracking(record) {
      this.selectedRecord = this.getSelectedRecord(record);
      this.showEditServiceTrackingDialog = true;
    },
    closeEditServiceTracking: function closeEditServiceTracking() {
      this.showEditServiceTrackingDialog = false;
    },
    openDeleteServiceTracking: function openDeleteServiceTracking(record) {
      this.selectedRecord = this.getSelectedRecord(record);
      this.showDeleteServiceTrackingConfirmDialog = true;
    },
    closeDeleteServiceTracking: function closeDeleteServiceTracking() {
      this.showDeleteServiceTrackingConfirmDialog = false;
      this.resetTrackings();
    },
    openApproveServiceTracking: function openApproveServiceTracking(record) {
      record.approved = true;
      this.selectedRecord = this.getSelectedRecord(record);
      this.showApproveServiceTrackingDialog = true;
    },
    getSelectedRecord: function getSelectedRecord(record) {
      return {
        id: record.id,
        user: record.user,
        customer: record.customer,
        service: record.service,
        date: this.getDay(record.startTime),
        startTime: this.getTime(record.startTime),
        finishTime: this.getTime(record.finishTime)
      };
    },
    closeApproveServiceTracking: function closeApproveServiceTracking() {
      this.showApproveServiceTrackingDialog = false;
      this.resetTrackings();
    },
    resetTrackings: function resetTrackings() {
      this.page = 0;
      this.size = 20;
      this.$store.dispatch('resetServiceTrackings');
      this.loadMyServicesTrackings();
    }
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewServiceTrackingDialog_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae20b3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewServiceTrackingDialog_vue__ = __webpack_require__(347);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewServiceTrackingDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae20b3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewServiceTrackingDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewServiceTrackingDialog',
  props: ['show'],
  data: function data() {
    return {
      today: this.getToday(),
      services: [],
      selectedCustomer: null,
      showInfos: false,
      serviceTrackingForm: {
        valid: false,
        customer: null,
        service: null,
        date: this.getDefaultDate(),
        startTime: null,
        finishTime: null
      },
      datePickerOptions: {
        disabledDate: function disabledDate(date) {
          var today = new Date();
          var priorDate = new Date(new Date().setDate(today.getDate() - 60));
          return date < priorDate || date > today;
        }
      },
      timerPickerOptions: {
        start: '07:00',
        step: '00:15',
        end: '22:00'
      },
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }]
    };
  },

  computed: {
    customers: function customers() {
      return this.$store.getters.user.customers;
    },
    submitAllowed: function submitAllowed() {
      return this.serviceTrackingForm.customer !== null && this.serviceTrackingForm.service !== null && this.serviceTrackingForm.date !== null && this.serviceTrackingForm.startTime !== null && this.serviceTrackingForm.finishTime !== null;
    }
  },
  watch: {
    selectedCustomer: function selectedCustomer(newCustomer) {
      var _this = this;

      if (newCustomer) {
        this.serviceTrackingForm.customer = newCustomer;
        var definitions = this.customers.find(function (customer) {
          return customer.id === newCustomer.id;
        }).customerServiceDefinitions;
        definitions.forEach(function (definition) {
          return _this.services.push(definition.service);
        });
      }
    }
  },
  methods: {
    createServiceTracking: function createServiceTracking() {
      var _this2 = this;

      var currentUser = this.$store.getters.user;
      this.$store.dispatch('addServiceTracking', {
        user: { id: currentUser.id, email: currentUser.username, roles: currentUser.roles },
        service: this.serviceTrackingForm.service,
        customer: this.serviceTrackingForm.customer,
        startTime: this.calcTime(this.serviceTrackingForm.date, this.serviceTrackingForm.startTime),
        finishTime: this.calcTime(this.serviceTrackingForm.date, this.serviceTrackingForm.finishTime)
      }).finally(function () {
        return _this2.close();
      });
    },
    getToday: function getToday() {
      return new Date().toJSON().slice(0, 10);
    },
    getDefaultDate: function getDefaultDate() {
      return new Date().setHours(0, 0, 0, 0);
    },
    calcTime: function calcTime(date, time) {
      var t = time.split(':');
      return date + (t[0] * 60 * 60000 + t[1] * 60000);
    },
    close: function close() {
      this.clearForm();
      this.$emit('close');
    },
    clearForm: function clearForm() {
      this.$refs.form.reset();
      this.services = [];
      this.serviceTrackingForm = initialState();
      this.today = this.getToday();
    }
  }
});

function initialState() {
  return {
    valid: false,
    customer: null,
    service: null,
    date: null,
    startTime: null,
    finishTime: null
  };
}

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditServiceTrackingDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    serviceTracking: {
      type: Object,
      default: function _default() {
        return {
          user: null,
          customer: null,
          service: null,
          date: null,
          startTime: null,
          finishTime: null,
          approachCharge: false
        };
      }
    }
  },
  data: function data() {
    return {
      services: [],
      customers: [],
      selectedCustomer: null,
      showInfos: false,
      valid: false,
      timerPickerOptions: {
        start: '07:00',
        step: '00:15',
        end: '22:00'
      },
      datePickerOptions: {
        disabledDate: function disabledDate(date) {
          var today = new Date();
          var priorDate = new Date(new Date().setDate(today.getDate() - 60));
          return date < priorDate || date > today;
        }
      },
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    submitAllowed: function submitAllowed() {
      return this.serviceTracking.customer !== null && this.serviceTracking.service !== null && this.serviceTracking.date !== null && this.serviceTracking.startTime !== null && this.serviceTracking.finishTime !== null;
    }
  },
  watch: {
    serviceTracking: function serviceTracking(newTracking) {
      this.selectedCustomer = newTracking.customer;
      this.customers = newTracking.user.customers;
    },
    selectedCustomer: function selectedCustomer(newCustomer) {
      var _this = this;

      if (newCustomer) {
        this.serviceTracking.customer = newCustomer;
        var definitions = this.customers.find(function (customer) {
          return customer.id === newCustomer.id;
        }).customerServiceDefinitions;
        definitions.forEach(function (definition) {
          return _this.services.push(definition.service);
        });
      }
    }
  },
  methods: {
    updateServiceTracking: function updateServiceTracking() {
      var _this2 = this;

      this.$store.dispatch('updateServiceTrackingOfMy', {
        id: this.serviceTracking.id,
        user: this.serviceTracking.user,
        customer: this.serviceTracking.customer,
        service: this.serviceTracking.service,
        startTime: this.calcTime(this.serviceTracking.date, this.serviceTracking.startTime),
        finishTime: this.calcTime(this.serviceTracking.date, this.serviceTracking.finishTime),
        approachCharge: this.serviceTracking.approachCharge
      }).finally(function () {
        return _this2.$emit('close');
      });
    },
    calcTime: function calcTime(date, time) {
      var t = time.split(':');
      return date + (t[0] * 60 * 60000 + t[1] * 60000);
    },
    disabledDate: function disabledDate(date) {
      var today = new Date();
      var priorDate = new Date(new Date().setDate(today.getDate() - 60));
      return date < priorDate;
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteServiceTrackingConfirmDialog_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edc84c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteServiceTrackingConfirmDialog_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6edc84c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteServiceTrackingConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edc84c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteServiceTrackingConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteServiceTrackingConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    serviceTracking: {
      type: Object,
      default: function _default() {
        return {
          id: 0
        };
      }
    }
  },
  methods: {
    deleteServiceTracking: function deleteServiceTracking() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].deleteServiceTracking(this.serviceTracking.id).then(function () {
        return _this.$store.dispatch('showNotification', {
          title: 'Zeiterfassung erfolgreich gelöscht.',
          type: 'primary'
        });
      }).finally(function () {
        return _this.$emit('close');
      });
    }
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveServiceTrackingDialog_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea301432_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveServiceTrackingDialog_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea301432"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveServiceTrackingDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea301432_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveServiceTrackingDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ApproveServiceTrackingDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    serviceTracking: {
      type: Object,
      default: function _default() {
        return {
          id: 0
        };
      }
    }
  },
  methods: {
    approveServiceTracking: function approveServiceTracking() {
      this.$store.dispatch('approveServiceTracking', this.serviceTracking);
      this.$emit('close');
    },
    closeApproveDialog: function closeApproveDialog() {
      this.serviceTracking.approved = false;
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditServiceTrackingDialog__ = __webpack_require__(127);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyApprovedServiceTracking',
  components: {
    'edit-service-tracking-dialog': __WEBPACK_IMPORTED_MODULE_0__EditServiceTrackingDialog__["a" /* default */]
  },
  data: function data() {
    return {
      page: 0,
      size: 20,
      bottom: false,
      showEditServiceTrackingDialog: false,
      selectedRecord: {
        id: null,
        customer: null,
        service: null,
        date: null,
        startTime: null,
        finishTime: null,
        approved: false
      }
    };
  },

  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.page++;
        this.loadMyApprovedServicesTrackings();
      }
    }
  },
  computed: {
    myTrackings: function myTrackings() {
      return this.$store.getters.myApprovedServiceTrackings;
    }
  },
  created: function created() {
    this.$store.dispatch('loadUserData', this.$store.getters.user);
    this.resetTrackings();
  },

  methods: {
    loadMyApprovedServicesTrackings: function loadMyApprovedServicesTrackings() {
      this.$store.dispatch('loadMyApprovedServicesTrackings', {
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    getDate: function getDate(millis) {
      var date = new Date(millis);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      return dd + '.' + mm + '.' + yyyy;
    },
    getTime: function getTime(millis) {
      var date = new Date(millis);
      var mn = date.getMinutes();
      var hr = date.getHours();

      if (mn < 10) {
        mn = '0' + mn;
      }

      if (hr < 10) {
        hr = '0' + hr;
      }

      return hr + ':' + mn;
    },
    getDay: function getDay(millis) {
      var ms = new Date(millis);
      var msPerDay = 86400000;
      var beginning = ms - ms % msPerDay;
      beginning += new Date().getTimezoneOffset() * 60 * 1000;
      return beginning;
    },
    openEditServiceTracking: function openEditServiceTracking(record) {
      this.selectedRecord = {
        id: record.id,
        user: record.user,
        customer: record.customer,
        service: record.service,
        date: this.getDay(record.startTime),
        startTime: this.getTime(record.startTime),
        finishTime: this.getTime(record.finishTime)
      };
      this.showEditServiceTrackingDialog = true;
    },
    closeEditServiceTracking: function closeEditServiceTracking() {
      this.showEditServiceTrackingDialog = false;
    },
    resetTrackings: function resetTrackings() {
      this.page = 0;
      this.size = 20;
      this.$store.dispatch('resetApprovedServiceTrackings');
      this.loadMyApprovedServicesTrackings();
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewServiceTrackingDialog__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditServiceTrackingDialog__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeleteServiceTrackingConfirmDialog__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApproveServiceTrackingDialog__ = __webpack_require__(255);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ServiceTracking',
  components: {
    'new-tracking-dialog': __WEBPACK_IMPORTED_MODULE_0__NewServiceTrackingDialog__["a" /* default */],
    'edit-service-tracking-dialog': __WEBPACK_IMPORTED_MODULE_1__EditServiceTrackingDialog__["a" /* default */],
    'delete-service-tracking-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__DeleteServiceTrackingConfirmDialog__["a" /* default */],
    'approve-service-tracking-dialog': __WEBPACK_IMPORTED_MODULE_3__ApproveServiceTrackingDialog__["a" /* default */]
  },
  data: function data() {
    return {
      page: 0,
      size: 30,
      bottom: false,
      showNewServiceTrackingDialog: false,
      showEditServiceTrackingDialog: false,
      showDeleteServiceTrackingConfirmDialog: false,
      showApproveServiceTrackingDialog: false,
      selectedRecord: {
        id: null,
        customer: null,
        service: null,
        date: null,
        startTime: null,
        finishTime: null,
        approved: false
      }
    };
  },

  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.page++;
        this.loadAllServicesTrackings();
      }
    }
  },
  computed: {
    allTrackings: function allTrackings() {
      return this.$store.getters.allServiceTrackings;
    }
  },
  created: function created() {
    this.resetTrackings();
  },

  methods: {
    loadAllServicesTrackings: function loadAllServicesTrackings() {
      this.$store.dispatch('loadAllServicesTrackings', {
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    getDate: function getDate(millis) {
      var date = new Date(millis);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      return dd + '.' + mm + '.' + yyyy;
    },
    getTime: function getTime(millis) {
      var date = new Date(millis);
      var mn = date.getMinutes();
      var hr = date.getHours();

      if (mn < 10) {
        mn = '0' + mn;
      }

      if (hr < 10) {
        hr = '0' + hr;
      }

      return hr + ':' + mn;
    },
    getDay: function getDay(millis) {
      var ms = new Date(millis);
      var msPerDay = 86400000;
      var beginning = ms - ms % msPerDay;
      beginning += new Date().getTimezoneOffset() * 60 * 1000;
      return beginning;
    },
    getSubheader: function getSubheader(group) {
      if (group[0]) {
        return group[0].user.lastName + ', ' + group[0].user.firstName + ':';
      }
      return '';
    },
    mapYearMonth: function mapYearMonth(yearMonth) {
      var splitted = yearMonth.split('-');
      var date = new Date(splitted[0], splitted[1] - 1);
      return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0];
    },
    openNewServiceTracking: function openNewServiceTracking() {
      this.showNewServiceTrackingDialog = true;
    },
    closeNewServiceTracking: function closeNewServiceTracking() {
      this.showNewServiceTrackingDialog = false;
      this.resetTrackings();
    },
    openEditServiceTracking: function openEditServiceTracking(record) {
      this.selectedRecord = {
        id: record.id,
        user: record.user,
        customer: record.customer,
        service: record.service,
        date: this.getDay(record.startTime),
        startTime: this.getTime(record.startTime),
        finishTime: this.getTime(record.finishTime)
      };
      this.showEditServiceTrackingDialog = true;
    },
    closeEditServiceTracking: function closeEditServiceTracking() {
      this.showEditServiceTrackingDialog = false;
    },
    openDeleteServiceTracking: function openDeleteServiceTracking(record) {
      this.selectedRecord = { id: record.id };
      this.showDeleteServiceTrackingConfirmDialog = true;
    },
    closeDeleteServiceTracking: function closeDeleteServiceTracking() {
      this.showDeleteServiceTrackingConfirmDialog = false;
      this.resetTrackings();
    },
    openApproveServiceTracking: function openApproveServiceTracking(record) {
      record.approved = true;
      this.selectedRecord = record;
      this.showApproveServiceTrackingDialog = true;
    },
    closeApproveServiceTracking: function closeApproveServiceTracking() {
      this.showApproveServiceTrackingDialog = false;
      if (this.getNumberOfDisplayedTrackings() < 15) {
        this.page++;
        this.loadAllServicesTrackings();
      }
    },
    getNumberOfDisplayedTrackings: function getNumberOfDisplayedTrackings() {
      var trackingsNumber = 0;
      this.allTrackings.forEach(function (monthGroup) {
        monthGroup.userGroupedServiceTrackings.forEach(function (trackingsOfUserPerMonth) {
          trackingsNumber += trackingsOfUserPerMonth.usersServiceTracking.length;
        });
      });
      return trackingsNumber;
    },
    resetTrackings: function resetTrackings() {
      this.page = 0;
      this.size = 30;
      this.$store.dispatch('resetServiceTrackings');
      this.loadAllServicesTrackings();
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignIn',
  data: function data() {
    return {
      email: '',
      password: '',
      newPassword: '',
      valid: false,
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      emailRules: [function (v) {
        return !!v || 'E-Mail nicht angegeben';
      }, function (v) {
        return (/(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Passwort nicht angegeben';
      }, function (v) {
        return v && v.length >= 8 || 'Ein Passwort muss min. 8 Zeichen enthalten';
      }, function (v) {
        return (/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        );
      }]
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    passwordChange: function passwordChange() {
      return this.$store.getters.changePassword;
    },
    loginFailed: function loginFailed() {
      return this.$store.getters.loginFailed;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.replace(this.$route.query.from);
      }
    },
    loginFailed: function loginFailed(_loginFailed) {
      if (_loginFailed === true) {
        this.clear();
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    clear: function clear() {
      this.password = '';
    },
    onPasswordChanged: function onPasswordChanged() {
      this.$store.dispatch('newUserPassword', { user: this.user, password: this.newPassword });
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignOut'
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewCustomerDialog__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCustomerDialog__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteCustomerConfirmDialog__ = __webpack_require__(515);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Customers',
  data: function data() {
    return {
      searchTerm: '',
      page: 0,
      size: 50,
      bottom: false,
      showNewCustomerDialog: false,
      showEditCustomerDialog: false,
      showDeleteCustomerConfirmDialog: false,
      selectedCustomer: {
        firstName: '',
        lastName: ''
      }
    };
  },

  components: {
    'new-customer-dialog': __WEBPACK_IMPORTED_MODULE_1__NewCustomerDialog__["a" /* default */],
    'edit-customer-dialog': __WEBPACK_IMPORTED_MODULE_2__EditCustomerDialog__["a" /* default */],
    'delete-customer-dialog': __WEBPACK_IMPORTED_MODULE_3__DeleteCustomerConfirmDialog__["a" /* default */]
  },
  computed: {
    customers: function customers() {
      return this.$store.getters.customers;
    },
    maxCustomers: function maxCustomers() {
      return this.$store.getters.maxCustomers;
    }
  },
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom && this.customers.length < this.maxCustomers) {
        this.page++;
        this.searchCustomers(this.searchTerm);
      }
    },
    searchTerm: function searchTerm(_searchTerm) {
      this.page = 0;
      this.$store.dispatch('resetCustomers');
      if (_searchTerm === null) {
        this.searchTerm = '';
        this.searchCustomers(this.searchTerm);
      } else {
        this.debouncedSearchCustomers(this.searchTerm);
      }
    }
  },
  created: function created() {
    this.$store.dispatch('resetCustomers');
    this.debouncedSearchCustomers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(this.searchCustomers, 500);
    this.searchCustomers(this.searchTerm);
  },

  methods: {
    searchCustomers: function searchCustomers(searchTerm) {
      this.$store.dispatch('loadCustomers', {
        searchTerms: searchTerm.split(' '),
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    openNewDialog: function openNewDialog() {
      this.showNewCustomerDialog = true;
      this.resetSearch();
    },
    closeNewDialog: function closeNewDialog() {
      this.showNewCustomerDialog = false;
    },
    openEditDialog: function openEditDialog(customer) {
      this.selectedCustomer = customer;
      this.showEditCustomerDialog = true;
    },
    closeEditDialog: function closeEditDialog() {
      this.showEditCustomerDialog = false;
    },
    openDeleteDialog: function openDeleteDialog(customer) {
      this.selectedCustomer = customer;
      this.showDeleteCustomerConfirmDialog = true;
    },
    closeDeleteDialog: function closeDeleteDialog() {
      this.showDeleteCustomerConfirmDialog = false;
    },
    resetSearch: function resetSearch() {
      this.searchTerm = '';
      this.searchCustomers(this.searchTerm);
    }
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewCustomerDialog',
  props: ['show'],
  data: function data() {
    return {
      page: 0,
      size: 50,
      dialog: false,
      customerForm: {
        valid: false,
        email: '',
        salutation: 'EMPTY',
        firstName: '',
        lastName: '',
        business: false,
        addition: '',
        approachCharge: false,
        approachChargeValue: '',
        fixDrives: false,
        fixDrivesNumber: 0,
        customerServiceDefinitions: [],
        fareUsers: [],
        street: '',
        city: '',
        zipCode: '',
        phoneNumber: '',
        infos: '',
        internalInfos: '',
        calculateVat: true
      },
      currencyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        precision: 2
      },
      headers: [{
        text: 'Dienstleistung',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: 'Beschreibung',
        align: 'left',
        sortable: false,
        value: 'description'
      }, {
        text: 'Extrazeile 1',
        align: 'left',
        sortable: false,
        value: 'extraLine1'
      }, {
        text: 'Extrazeile 2',
        align: 'left',
        sortable: false,
        value: 'extraLine2'
      }, {
        text: 'Extrazeile 3',
        align: 'left',
        sortable: false,
        value: 'extraLine3'
      }, {
        text: 'Abrechnungsrhythmus',
        align: 'left',
        sortable: false,
        value: 'frequency'
      }, {
        text: 'Pauschale?',
        align: 'left',
        sortable: false,
        value: 'flatRate'
      }, {
        text: 'Pauschalbetrag',
        align: 'left',
        sortable: false,
        value: 'flatRateFee'
      }, {
        text: 'Aktionen',
        align: 'left',
        sortable: false,
        value: 'action'
      }],
      editedIndex: -1,
      editedItem: {
        service: {
          id: 0,
          name: ''
        },
        description: '',
        extraLine1: '',
        extraLine2: '',
        extraLine3: '',
        flatRate: false,
        flatRateFee: '0,00',
        frequency: 'HOURLY'
      },
      defaultItem: {
        service: {
          id: 0,
          name: ''
        },
        description: '',
        extraLine1: '',
        extraLine2: '',
        extraLine3: '',
        flatRate: false,
        flatRateFee: '0,00',
        frequency: 'HOURLY'
      },
      salutations: [{
        value: 'EMPTY',
        text: ''
      }, {
        value: 'SIR',
        text: 'Herr'
      }, {
        value: 'MADAM',
        text: 'Frau'
      }, {
        value: 'FAMILY',
        text: 'Familie'
      }, {
        value: 'COMPANY',
        text: 'Firma'
      }],
      frequencies: [{
        value: 'HOURLY',
        text: 'Stündlich',
        disabled: false
      }, {
        value: 'DAILY',
        text: 'Täglich',
        disabled: true
      }, {
        value: 'MONTHLY',
        text: 'Monatlich',
        disabled: true
      }],
      numberRule: [function (n) {
        return !!n || !isNaN(n) || 'Dieses Feld muss eine Zahl sein';
      }],
      salutationRule: [function (v) {
        return !!v || 'Bitte wählen sie eine Begrüßung aus';
      }],
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      emailRules: [function (v) {
        return !!v || 'E-Mail nicht angegeben';
      }, function (v) {
        return (/(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        );
      }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    users: function users() {
      return this.$store.getters.allUsers;
    },
    loadUsers: function loadUsers() {
      return __WEBPACK_IMPORTED_MODULE_1_debounce___default()(this.fetchUsers, 500);
    },
    customerServiceDefinitions: function customerServiceDefinitions() {
      var allServices = this.$store.getters.services;
      return allServices.map(function (service) {
        return {
          name: service.name,
          service: {
            id: service.id,
            name: service.name
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        };
      });
    },
    editItemFlatRate: function editItemFlatRate() {
      return this.editedItem.flatRate;
    }
  },
  watch: {
    editItemFlatRate: function editItemFlatRate(newFlatRate, oldFlatRate) {
      if (oldFlatRate && !newFlatRate) {
        this.frequencies.forEach(function (frequency) {
          if (frequency.value === 'HOURLY') {
            frequency.disabled = false;
          } else {
            frequency.disabled = true;
          }
        });
        this.editedItem.frequency = 'HOURLY';
      } else {
        this.frequencies.forEach(function (frequency) {
          if (frequency.value === 'HOURLY') {
            frequency.disabled = true;
          } else {
            frequency.disabled = false;
          }
        });
        if (this.editedItem.frequency === 'HOURLY') {
          this.editedItem.frequency = 'MONTHLY';
        }
      }
    }
  },
  created: function created() {
    this.$store.dispatch('loadServices', {
      searchTerms: ''.split(' '),
      page: this.page,
      size: this.size
    });
  },

  methods: {
    createCustomer: function createCustomer() {
      var _this = this;

      this.$store.dispatch('addCustomer', {
        email: this.customerForm.email,
        approachCharge: this.customerForm.approachCharge,
        approachChargeValue: this.mapToFloat(this.customerForm.approachChargeValue),
        fixDrives: this.customerForm.approachCharge && this.customerForm.fixDrives,
        fixDrivesNumber: this.getFixDrivesNumber(),
        customerServiceDefinitions: this.mapCustomerServiceDefinitions(this.customerForm.customerServiceDefinitions),
        fareUsers: this.customerForm.fareUsers,
        business: this.customerForm.business,
        addition: this.customerForm.addition,
        salutation: this.customerForm.salutation,
        firstName: this.customerForm.firstName,
        lastName: this.customerForm.lastName,
        street: this.customerForm.street,
        city: this.customerForm.city,
        zipCode: this.customerForm.zipCode,
        phoneNumber: this.customerForm.phoneNumber,
        infos: this.customerForm.infos,
        internalInfos: this.customerForm.internalInfos,
        calculateVat: this.customerForm.calculateVat
      }).then(function () {
        return _this.$store.dispatch('showNotification', {
          title: 'Kunde erfolgreich geandert.',
          type: 'primary'
        });
      }).finally(function () {
        return _this.close();
      });
    },
    loadNextEmployeePage: function loadNextEmployeePage() {
      this.page++;
      this.fetchUsers();
    },
    fetchUsers: function fetchUsers() {
      this.$store.dispatch('loadUsers', {
        searchTerms: ''.split(' '),
        page: this.page,
        size: this.size
      });
    },
    serviceValue: function serviceValue(item) {
      return item.service.id;
    },
    serviceText: function serviceText(item) {
      if (!Array.isArray(item)) {
        return item.service.name;
      }
    },
    getFixDrivesNumber: function getFixDrivesNumber() {
      if (!this.customerForm.approachCharge || !this.customerForm.fixDrives) {
        return 0;
      }
      return this.customerForm.fixDrivesNumber;
    },
    textRateNameMapping: function textRateNameMapping(item) {
      return item.service.name;
    },
    mapCustomerServiceDefinitions: function mapCustomerServiceDefinitions(definitions) {
      var _this2 = this;

      return definitions.map(function (definition) {
        return {
          id: definition.id,
          service: {
            id: definition.service.id,
            name: definition.service.name
          },
          description: definition.description,
          extraLine1: definition.extraLine1,
          extraLine2: definition.extraLine2,
          extraLine3: definition.extraLine3,
          flatRate: definition.flatRate,
          flatRateFee: _this2.mapToFloat(definition.flatRateFee),
          frequency: definition.frequency
        };
      });
    },
    userValue: function userValue(item) {
      if (Array.isArray(item)) {
        return item;
      }
      return item.id;
    },
    userText: function userText(item) {
      return item.lastName + ', ' + item.firstName;
    },
    mapToFloat: function mapToFloat(nonFloatNumber) {
      if (isNaN(nonFloatNumber)) {
        return parseFloat(nonFloatNumber.replace(',', '.'));
      }
      return nonFloatNumber;
    },
    toCurrencyString: function toCurrencyString(flatRateFee) {
      if (typeof flatRateFee === 'string') {
        return flatRateFee;
      }
      return flatRateFee.toFixed(2).replace('.', ',');
    },
    mapFlareUsers: function mapFlareUsers(users) {
      var _this3 = this;

      var usersArray = [];

      users.forEach(function (user) {
        if (user.id) {
          usersArray.push(_this3.users.find(function (u) {
            return u.id === user.id;
          }));
        } else {
          usersArray.push(_this3.users.find(function (u) {
            return u.id === user;
          }));
        }
      });

      return usersArray;
    },
    getFrequencyRowText: function getFrequencyRowText(frequencyValue) {
      if (frequencyValue) {
        var frequency = this.frequencies.find(function (frequency) {
          return frequency.value === frequencyValue;
        });
        return frequency.text;
      }
    },
    edit: function edit(item) {
      this.editedIndex = this.customerForm.customerServiceDefinitions.findIndex(function (definition) {
        return definition.service.id === item.service.id;
      });
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    closeDefinitionDialog: function closeDefinitionDialog() {
      var _this4 = this;

      this.dialog = false;
      setTimeout(function () {
        _this4.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.defaultItem);
        _this4.editedIndex = -1;
      }, 300);
    },
    saveDefinition: function saveDefinition() {
      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.customerForm.customerServiceDefinitions[this.editedIndex], this.editedItem);
      } else {
        this.customerForm.customerServiceDefinitions.push(this.editedItem);
      }
      this.closeDefinitionDialog();
    },
    remove: function remove(item) {
      var foundIndex = this.customerForm.customerServiceDefinitions.findIndex(function (definition) {
        return definition.service.id === item.service.id;
      });
      if (foundIndex > -1) this.customerForm.customerServiceDefinitions.splice(foundIndex, 1);
    },
    removeUser: function removeUser(item) {
      var foundIndex = this.customerForm.fareUsers.indexOf(item);
      if (foundIndex > -1) this.customerForm.fareUsers.splice(foundIndex, 1);
    },
    close: function close() {
      this.clearForm();
      this.$emit('close');
    },
    clearForm: function clearForm() {
      this.customerForm = initialState();
      this.$refs.form.reset();
    }
  }
});

function initialState() {
  return {
    valid: false,
    email: '',
    firstName: '',
    lastName: '',
    business: false,
    approachCharge: false,
    approachChargeValue: '',
    fixDrives: false,
    fixDrivesNumber: 0,
    textRate: false,
    customerServiceDefinitions: [],
    street: '',
    city: '',
    zipCode: '',
    phoneNumber: ''
  };
}

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditCustomerDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: function _default() {
        return {
          valid: false,
          email: '',
          salutation: '',
          firstName: '',
          lastName: '',
          business: false,
          addition: '',
          approachCharge: false,
          approachChargeValue: '',
          fixDrives: false,
          fixDrivesNumber: 0,
          customerServiceDefinitions: [],
          fareUsers: [],
          street: '',
          city: '',
          zipCode: '',
          phoneNumber: '',
          infos: '',
          internalInfos: '',
          calculateVat: true
        };
      }
    }
  },
  data: function data() {
    return {
      valid: true,
      page: 0,
      size: 50,
      dialog: false,
      currencyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        precision: 2
      },
      headers: [{
        text: 'Dienstleistung',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: 'Beschreibung',
        align: 'left',
        sortable: false,
        value: 'description'
      }, {
        text: 'Extrazeile 1',
        align: 'left',
        sortable: false,
        value: 'extraLine1'
      }, {
        text: 'Extrazeile 2',
        align: 'left',
        sortable: false,
        value: 'extraLine2'
      }, {
        text: 'Extrazeile 3',
        align: 'left',
        sortable: false,
        value: 'extraLine3'
      }, {
        text: 'Abrechnungsrhythmus',
        align: 'left',
        sortable: false,
        value: 'frequency'
      }, {
        text: 'Pauschale?',
        align: 'left',
        sortable: false,
        value: 'flatRate'
      }, {
        text: 'Pauschalbetrag',
        align: 'left',
        sortable: false,
        value: 'flatRateFee'
      }, {
        text: 'Aktionen',
        align: 'left',
        sortable: false,
        value: 'action'
      }],
      editedIndex: -1,
      editedItem: {
        service: {
          id: 0,
          name: ''
        },
        description: '',
        extraLine1: '',
        extraLine2: '',
        extraLine3: '',
        flatRate: false,
        flatRateFee: '0,00',
        frequency: 'HOURLY'
      },
      defaultItem: {
        service: {
          id: 0,
          name: ''
        },
        description: '',
        extraLine1: '',
        extraLine2: '',
        extraLine3: '',
        flatRate: false,
        flatRateFee: '0,00',
        frequency: 'HOURLY'
      },
      salutations: [{
        value: 'EMPTY',
        text: ''
      }, {
        value: 'SIR',
        text: 'Herr'
      }, {
        value: 'MADAM',
        text: 'Frau'
      }, {
        value: 'FAMILY',
        text: 'Familie'
      }, {
        value: 'COMPANY',
        text: 'Firma'
      }],
      frequencies: [{
        value: 'HOURLY',
        text: 'Stündlich',
        disabled: false
      }, {
        value: 'DAILY',
        text: 'Täglich',
        disabled: true
      }, {
        value: 'MONTHLY',
        text: 'Monatlich',
        disabled: true
      }],
      numberRule: [function (n) {
        return !!n || !isNaN(n) || 'Dieses Feld muss eine Zahl sein';
      }],
      salutationRule: [function (v) {
        return !!v || 'Bitte wählen sie eine Begrüßung aus';
      }],
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      emailRules: [function (v) {
        return !!v || 'E-Mail nicht angegeben';
      }, function (v) {
        return (/(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        );
      }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    users: function users() {
      return this.$store.getters.allUsers;
    },
    loadUsers: function loadUsers() {
      return __WEBPACK_IMPORTED_MODULE_1_debounce___default()(this.fetchUsers, 500);
    },
    customerServiceDefinitions: function customerServiceDefinitions() {
      var allServices = this.$store.getters.services;
      return allServices.map(function (service) {
        return {
          name: service.name,
          service: {
            id: service.id,
            name: service.name
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        };
      });
    },
    editItemFlatRate: function editItemFlatRate() {
      return this.editedItem.flatRate;
    }
  },
  watch: {
    editItemFlatRate: function editItemFlatRate(newFlatRate, oldFlatRate) {
      if (oldFlatRate && !newFlatRate) {
        this.frequencies.forEach(function (frequency) {
          if (frequency.value === 'HOURLY') {
            frequency.disabled = false;
          } else {
            frequency.disabled = true;
          }
        });
        this.editedItem.frequency = 'HOURLY';
      } else {
        this.frequencies.forEach(function (frequency) {
          if (frequency.value === 'HOURLY') {
            frequency.disabled = true;
          } else {
            frequency.disabled = false;
          }
        });
        if (this.editedItem.frequency === 'HOURLY') {
          this.editedItem.frequency = 'MONTHLY';
        }
      }
    }
  },
  created: function created() {
    this.$store.dispatch('loadServices', {
      searchTerms: ''.split(' '),
      page: this.page,
      size: this.size
    });

    this.$store.dispatch('loadUsers', {
      searchTerms: ''.split(' '),
      page: this.page,
      size: this.size
    });
  },

  methods: {
    updateCustomer: function updateCustomer() {
      var _this = this;

      this.$store.dispatch('editCustomer', {
        id: this.customer.id,
        email: this.customer.email,
        approachCharge: this.customer.approachCharge,
        approachChargeValue: this.customer.approachChargeValue,
        fixDrives: this.customer.approachCharge && this.customer.fixDrives,
        fixDrivesNumber: this.customer.fixDrivesNumber,
        customerServiceDefinitions: this.mapCustomerServiceDefinitions(this.customer.customerServiceDefinitions),
        fareUsers: this.mapFlareUsers(this.customer.fareUsers),
        business: this.customer.business,
        addition: this.customer.addition,
        salutation: this.customer.salutation,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        street: this.customer.street,
        city: this.customer.city,
        zipCode: this.customer.zipCode,
        phoneNumber: this.customer.phoneNumber,
        infos: this.customer.infos,
        internalInfos: this.customer.internalInfos,
        calculateVat: this.customer.calculateVat
      }).then(function () {
        return _this.$store.dispatch('showNotification', {
          title: 'Kunde erfolgreich gespeichert.',
          type: 'primary'
        });
      }).finally(function () {
        return _this.$emit('close');
      });
    },
    fetchUsers: function fetchUsers(event) {
      if (event.target.value.length > 2) {
        this.$store.dispatch('resetUsers');
        this.$store.dispatch('loadUsers', {
          searchTerms: event.target.value.split(' '),
          page: this.page,
          size: this.size
        });
      }
    },
    serviceValue: function serviceValue(item) {
      if (Array.isArray(item)) {
        return item;
      }
      return item.service.id;
    },
    serviceText: function serviceText(item) {
      if (!Array.isArray(item)) {
        return item.service.name;
      }
    },
    textRateNameMapping: function textRateNameMapping(item) {
      return item.service.name;
    },
    mapCustomerServiceDefinitions: function mapCustomerServiceDefinitions(definitions) {
      var _this2 = this;

      return definitions.map(function (definition) {
        return {
          id: definition.id,
          service: {
            id: definition.service.id,
            name: definition.service.name
          },
          description: definition.description,
          extraLine1: definition.extraLine1,
          extraLine2: definition.extraLine2,
          extraLine3: definition.extraLine3,
          flatRate: definition.flatRate,
          flatRateFee: _this2.mapToFloat(definition.flatRateFee),
          frequency: definition.frequency
        };
      });
    },
    userValue: function userValue(item) {
      if (Array.isArray(item)) {
        return item;
      }
      return item.id;
    },
    userText: function userText(item) {
      return item.lastName + ', ' + item.firstName;
    },
    mapToFloat: function mapToFloat(nonFloatNumber) {
      if (isNaN(nonFloatNumber)) {
        return parseFloat(nonFloatNumber.replace(',', '.'));
      }
      return nonFloatNumber;
    },
    mapflatRateFeeToString: function mapflatRateFeeToString(flatRateFee) {
      if (typeof flatRateFee === 'string') {
        return flatRateFee;
      }
      return flatRateFee.toFixed(2).replace('.', ',');
    },
    mapFlareUsers: function mapFlareUsers(users) {
      var _this3 = this;

      var usersArray = [];

      users.forEach(function (user) {
        if (user.id) {
          usersArray.push(_this3.users.find(function (u) {
            return u.id === user.id;
          }));
        } else {
          usersArray.push(_this3.users.find(function (u) {
            return u.id === user;
          }));
        }
      });

      return usersArray;
    },
    getFrequencyRowText: function getFrequencyRowText(frequencyValue) {
      if (frequencyValue) {
        var frequency = this.frequencies.find(function (frequency) {
          return frequency.value === frequencyValue;
        });
        return frequency.text;
      }
    },
    edit: function edit(item) {
      this.editedIndex = this.customer.customerServiceDefinitions.findIndex(function (definition) {
        return definition.service.id === item.service.id;
      });
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    closeDefinitionDialog: function closeDefinitionDialog() {
      var _this4 = this;

      this.dialog = false;
      setTimeout(function () {
        _this4.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.defaultItem);
        _this4.editedIndex = -1;
      }, 300);
    },
    saveDefinition: function saveDefinition() {
      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.customer.customerServiceDefinitions[this.editedIndex], this.editedItem);
      } else {
        this.customer.customerServiceDefinitions.push(this.editedItem);
      }
      this.closeDefinitionDialog();
    },
    remove: function remove(item) {
      var foundIndex = this.customer.customerServiceDefinitions.findIndex(function (definition) {
        return definition.service.id === item.service.id;
      });
      if (foundIndex > -1) this.customer.customerServiceDefinitions.splice(foundIndex, 1);
    },
    removeUser: function removeUser(item) {
      var fareUser = this.customer.fareUsers.find(function (fareUser) {
        return fareUser.id === item.id;
      });
      var foundIndex = this.customer.fareUsers.indexOf(fareUser);
      if (foundIndex > -1) this.customer.fareUsers.splice(foundIndex, 1);
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteCustomerConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          email: '',
          name: ''
        };
      }
    }
  },
  methods: {
    deleteCustomer: function deleteCustomer() {
      var _this = this;

      this.$store.dispatch('removeCustomer', this.customer.id).then(function () {
        return _this.$store.dispatch('showNotification', {
          title: 'Kunde erfolgreich gelöscht.',
          type: 'primary'
        });
      }).finally(function () {
        return _this.$emit('close');
      });
    }
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewServiceDialog__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditServiceDialog__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteServiceConfirmDialog__ = __webpack_require__(524);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Services',
  data: function data() {
    return {
      searchTerm: '',
      page: 0,
      size: 50,
      bottom: false,
      showNewServiceDialog: false,
      showEditServiceDialog: false,
      showDeleteServiceConfirmDialog: false,
      selectedService: {
        name: '',
        privateHourFee: '',
        businessHourFee: ''
      }
    };
  },

  components: {
    'new-service-dialog': __WEBPACK_IMPORTED_MODULE_1__NewServiceDialog__["a" /* default */],
    'edit-service-dialog': __WEBPACK_IMPORTED_MODULE_2__EditServiceDialog__["a" /* default */],
    'delete-service-dialog': __WEBPACK_IMPORTED_MODULE_3__DeleteServiceConfirmDialog__["a" /* default */]
  },
  computed: {
    services: function services() {
      return this.$store.getters.services;
    },
    maxServices: function maxServices() {
      return this.$store.getters.maxServices;
    }
  },
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom && this.services.length < this.maxServices) {
        this.page++;
        this.searchServices(this.searchTerm);
      }
    },
    searchTerm: function searchTerm(_searchTerm) {
      this.page = 0;
      this.$store.dispatch('resetServices');
      if (_searchTerm === null) {
        this.searchTerm = '';
        this.searchServices(this.searchTerm);
      } else {
        this.debouncedSearchServices(this.searchTerm);
      }
    }
  },
  created: function created() {
    this.debouncedSearchServices = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(this.searchServices, 500);
    this.$store.dispatch('resetServices');
    this.searchServices(this.searchTerm);
  },

  methods: {
    searchServices: function searchServices(searchTerm) {
      this.$store.dispatch('loadServices', {
        searchTerms: searchTerm.split(' '),
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    openNewService: function openNewService() {
      this.showNewServiceDialog = true;
    },
    closeNewService: function closeNewService() {
      this.showNewServiceDialog = false;
    },
    openEditService: function openEditService(service) {
      this.selectedService = service;
      this.showEditServiceDialog = true;
    },
    closeEditService: function closeEditService() {
      this.showEditServiceDialog = false;
    },
    openDeleteService: function openDeleteService(service) {
      this.selectedService = { id: service.id, name: service.name };
      this.showDeleteServiceConfirmDialog = true;
    },
    closeDeleteService: function closeDeleteService() {
      this.showDeleteServiceConfirmDialog = false;
    },
    resetSearch: function resetSearch() {
      this.pag = 0;
      this.size = 50;
      this.$store.dispatch('resetServices');
      this.searchTerm = '';
      this.debouncedSearchServices(this.searchTerm);
    },
    toCurrency: function toCurrency(currencyFloat) {
      if (typeof currencyFloat === 'string') {
        return currencyFloat;
      }

      return currencyFloat.toFixed(2).replace('.', ',');
    }
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewServiceDialog',
  props: ['show'],
  data: function data() {
    return {
      serviceForm: {
        valid: false,
        name: '',
        privateHourFee: 0.0,
        businessHourFee: 0.0
      },
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      currencyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        precision: 2
      }
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    createService: function createService() {
      var _this = this;

      this.$store.dispatch('addService', {
        name: this.serviceForm.name,
        privateHourFee: this.serviceForm.privateHourFee,
        businessHourFee: this.serviceForm.businessHourFee
      }).finally(function () {
        return _this.close();
      });
    },
    close: function close() {
      this.clearForm();
      this.$emit('close');
    },
    clearForm: function clearForm() {
      this.serviceForm = initialState();
      this.$refs.form.reset();
    }
  }
});

function initialState() {
  return {
    valid: false,
    name: '',
    privateHourFee: 0.0,
    businessHourFee: 0.0
  };
}

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditServiceDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          privateHourFee: 0.0,
          businessHourFee: 0.0
        };
      }
    }
  },
  data: function data() {
    return {
      valid: false,
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      currencyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        precision: 2
      }
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    updateService: function updateService() {
      var _this = this;

      this.$store.dispatch('editService', {
        id: this.service.id,
        name: this.service.name,
        privateHourFee: this.service.privateHourFee,
        businessHourFee: this.service.businessHourFee
      }).finally(function () {
        return _this.$emit('close');
      });
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteServiceConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          name: ''
        };
      }
    }
  },
  methods: {
    deleteService: function deleteService() {
      var _this = this;

      this.$store.dispatch('deleteService', this.service.id).finally(function () {
        return _this.$emit('close');
      });
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewUserDialog__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditUserDialog__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteUserConfirmDialog__ = __webpack_require__(532);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserManagement',
  data: function data() {
    return {
      searchTerm: '',
      page: 0,
      size: 50,
      bottom: false,
      showNewUserDialog: false,
      showEditUserDialog: false,
      showDeleteUserConfirmDialog: false,
      selectedUser: {
        email: '',
        role: null,
        customers: [],
        firstName: '',
        lastName: '',
        street: '',
        zipCode: '',
        city: ''
      }
    };
  },

  components: {
    'new-user-dialog': __WEBPACK_IMPORTED_MODULE_1__NewUserDialog__["a" /* default */],
    'edit-user-dialog': __WEBPACK_IMPORTED_MODULE_2__EditUserDialog__["a" /* default */],
    'delete-user-dialog': __WEBPACK_IMPORTED_MODULE_3__DeleteUserConfirmDialog__["a" /* default */]
  },
  computed: {
    users: function users() {
      return this.$store.getters.allUsers;
    },
    maxUsers: function maxUsers() {
      return this.$store.getters.maxUsers;
    }
  },
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom && this.users.length < this.maxUsers) {
        this.page++;
        this.searchUsers(this.searchTerm);
      }
    },
    searchTerm: function searchTerm(_searchTerm) {
      this.page = 0;
      this.$store.dispatch('resetUsers');
      if (_searchTerm === null) {
        this.searchTerm = '';
        this.searchUsers(this.searchTerm);
      } else {
        this.debouncedSearchUsers(this.searchTerm);
      }
    }
  },
  created: function created() {
    this.debouncedSearchUsers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(this.searchUsers, 500);

    this.$store.dispatch('loadRoles');
    this.$store.dispatch('resetCustomers');
    this.$store.dispatch('loadCustomers', {
      searchTerms: [],
      page: this.page,
      size: this.size
    });

    this.$store.dispatch('resetUsers');
    this.searchUsers(this.searchTerm);
  },

  methods: {
    searchUsers: function searchUsers(searchTerm) {
      this.$store.dispatch('loadUsers', {
        searchTerms: searchTerm.split(' '),
        page: this.page,
        size: this.size
      });
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    openEditUser: function openEditUser(user) {
      this.selectedUser = user;
      this.showEditUserDialog = true;
    },
    openNewUserDialog: function openNewUserDialog() {
      this.showNewUserDialog = true;
    },
    closeNewUserDialog: function closeNewUserDialog() {
      this.showNewUserDialog = false;
      // this.resetSearch()
    },
    closeEditUserDialog: function closeEditUserDialog() {
      this.showEditUserDialog = false;
      // this.resetSearch()
    },
    openDeleteUser: function openDeleteUser(user) {
      this.selectedUser = {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role,
        customers: user.customers,
        street: user.street,
        zipCode: user.zipCode,
        city: user.city
      };
      this.showDeleteUserConfirmDialog = true;
    },
    closeDeleteUserDialog: function closeDeleteUserDialog() {
      this.showDeleteUserConfirmDialog = false;
      this.resetSearch();
    },
    resetSearch: function resetSearch() {
      this.searchTerm = '';
      this.searchUsers(this.searchTerm);
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewUserDialog',
  props: ['show'],
  data: function data() {
    return {
      page: 0,
      size: 50,
      userForm: {
        valid: false,
        showPassword: false,
        email: '',
        password: '',
        role: null,
        customers: [],
        firstName: '',
        lastName: '',
        street: '',
        zipCode: '',
        city: ''
      },
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      emailRules: [function (v) {
        return !!v || 'E-Mail nicht angegeben';
      }, function (v) {
        return (/(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Passwort nicht angegeben';
      }, function (v) {
        return v && v.length >= 8 || 'Ein Passwort muss min. 8 Zeichen enthalten';
      }, function (v) {
        return (/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        );
      }],
      zipCodeRules: [function (v) {
        return !!v || 'Postleitzahl nicht angegeben';
      }, function (v) {
        return v && v.length === 5 || 'Die Postleitzahl muss genau 5 Zeichen lang sein';
      }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    customers: function customers() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.unionWith(this.userForm.customers.concat(this.$store.getters.customers), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual);
    },
    roles: function roles() {
      return this.$store.getters.roles;
    },
    loadCustomers: function loadCustomers() {
      return __WEBPACK_IMPORTED_MODULE_0_debounce___default()(this.fetchCustomers, 500);
    }
  },
  methods: {
    createUser: function createUser() {
      var _this = this;

      this.$store.dispatch('addUser', this.userForm).finally(function () {
        return _this.close();
      });
    },
    close: function close() {
      this.clearForm();
      this.$emit('close');
    },
    clearForm: function clearForm() {
      this.userForm = initialState();
      this.$refs.form.reset();
    },
    loadNextCustomerPage: function loadNextCustomerPage() {
      this.page++;
      this.fetchCustomers();
    },
    fetchCustomers: function fetchCustomers() {
      this.$store.dispatch('loadCustomers', {
        searchTerms: ''.split(' '),
        page: this.page,
        size: this.size
      });
    },
    customerValue: function customerValue(item) {
      return item.id;
    },
    customerText: function customerText(item) {
      return item.lastName + ' ' + item.firstName + ' - ' + item.street + ', ' + item.city;
    },
    remove: function remove(item) {
      var index = this.userForm.selectedCustomers.indexOf(item);
      if (index >= 0) this.userForm.selectedCustomers.splice(index, 1);
    }
  }
});

function initialState() {
  return {
    valid: false,
    showPassword: false,
    email: '',
    password: '',
    role: null,
    firstName: '',
    lastName: '',
    street: '',
    zipCode: '',
    city: ''
  };
}

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditUserDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function _default() {
        return {
          email: '',
          password: '',
          role: null,
          customers: [],
          firstName: '',
          lastName: '',
          street: '',
          zipCode: '',
          city: ''
        };
      }
    }
  },
  data: function data() {
    return {
      page: 0,
      size: 50,
      showPwField: false,
      showPassword: false,
      mandatoryFieldRule: [function (v) {
        return !!v || 'Dieses Feld darf nicht leer sein';
      }],
      emailRules: [function (v) {
        return !!v || 'E-Mail nicht angegeben';
      }, function (v) {
        return (/(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Passwort nicht angegeben';
      }, function (v) {
        return v && v.length >= 8 || 'Ein Passwort muss min. 8 Zeichen enthalten';
      }, function (v) {
        return (/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        );
      }],
      zipCodeRules: [function (v) {
        return !!v || 'Postleitzahl nicht angegeben';
      }, function (v) {
        return v && v.length === 5 || 'Die Postleitzahl muss genau 5 Zeichen lang sein';
      }]
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    allCustomers: function allCustomers() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.unionWith(this.user.customers.concat(this.$store.getters.customers), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual);
    },
    loadCustomers: function loadCustomers() {
      return __WEBPACK_IMPORTED_MODULE_0_debounce___default()(this.fetchCustomers, 500);
    },
    roles: function roles() {
      return this.$store.getters.roles;
    },
    valid: function valid() {
      return this.user.role !== null && this.user.firstName !== '' && this.user.lastName !== '' && this.user.street !== '' && this.user.zipCode !== '' && this.user.city !== '';
    }
  },
  methods: {
    updateUser: function updateUser() {
      var _this = this;

      this.$store.dispatch('editUser', this.mapCustomers(this.mapRoles(this.user))).finally(function () {
        return _this.$emit('close');
      });
    },
    loadNextCustomerPage: function loadNextCustomerPage() {
      this.page++;
      this.fetchCustomers();
    },
    fetchCustomers: function fetchCustomers() {
      this.$store.dispatch('loadCustomers', {
        searchTerms: ''.split(' '),
        page: this.page,
        size: this.size
      });
    },
    mapRoles: function mapRoles(user) {
      if (user.role.id) {
        user.role = this.roles[user.role.id - 1];
      } else {
        user.role = this.roles[user.role - 1];
      }
      return user;
    },
    mapCustomers: function mapCustomers(user) {
      var _this2 = this;

      var customers = user.customers;
      var customersArray = [];

      customers.forEach(function (customer) {
        if (customer.id) {
          customersArray.push(_this2.allCustomers.find(function (c) {
            return c.id === customer.id;
          }));
        } else {
          customersArray.push(_this2.allCustomers.find(function (c) {
            return c.id === customer;
          }));
        }
      });
      user.customers = customersArray;

      return user;
    },
    customerValue: function customerValue(item) {
      return item.id;
    },
    customerText: function customerText(item) {
      return item.lastName + ' ' + item.firstName + ' - ' + item.street + ', ' + item.city;
    },
    remove: function remove(item) {
      var foundIndex = this.user.customers.findIndex(function (customer) {
        return customer.id === item.id;
      });
      if (foundIndex > -1) this.user.customers.splice(foundIndex, 1);
    }
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteUserConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          email: '',
          firstName: '',
          lastName: ''
        };
      }
    }
  },
  methods: {
    deleteUser: function deleteUser() {
      var _this = this;

      this.$store.dispatch('deleteUser', this.user.id).finally(function () {
        return _this.$emit('close');
      });
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmployeeInvoiceList__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomerInvoiceList__ = __webpack_require__(540);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoices',
  data: function data() {
    return {
      tabs: null
    };
  },

  components: {
    'employee-invoice-list': __WEBPACK_IMPORTED_MODULE_0__EmployeeInvoiceList__["a" /* default */],
    'customer-invoice-list': __WEBPACK_IMPORTED_MODULE_1__CustomerInvoiceList__["a" /* default */]
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EmployeeInvoiceList',
  data: function data() {
    return {
      page: 0,
      size: 50,
      bottom: false,
      disabledInvoice: 0,
      selectedMonth: '',
      selectedMonths: [],
      selectedInvoices: []
    };
  },

  computed: {
    monthlyGroupInvoices: function monthlyGroupInvoices() {
      return this.$store.getters.employeeInvoices;
    },
    disabled: function disabled() {
      return this.$store.getters.startDataLoading;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.page++;
        this.loadEmployeeInvoices();
      }
    },
    disabled: function disabled(newValue, oldValue) {
      if (!newValue) {
        this.disabledInvoice = 0;
      }
    },

    monthlyGroupInvoices: {
      deep: true,
      handler: function handler() {
        this.selectAllInvoicesOfSelectedMonth();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('resetEmployerInvoices');
    window.addEventListener('scroll', function () {
      _this.bottom = _this.onScroll();
    });
    this.loadEmployeeInvoices();
  },

  methods: {
    loadEmployeeInvoices: function loadEmployeeInvoices(searchTerm) {
      this.$store.dispatch('loadEmployeeInvoices', {
        page: this.page,
        size: this.size
      });
    },
    monthSelectionChanged: function monthSelectionChanged(month, event) {
      if (event) {
        this.selectedMonth = month;
        this.selectAllInvoicesOfSelectedMonth();
      } else {
        this.deselectAllInvoicesOfSelectedMonth();
        this.selectedMonth = '';
      }
    },
    selectAllInvoicesOfSelectedMonth: function selectAllInvoicesOfSelectedMonth() {
      var _this2 = this;

      this.monthlyGroupInvoices.forEach(function (monthGroup) {
        monthGroup.invoices.forEach(function (invoice) {
          if (_this2.selectedMonth === monthGroup.month) {
            _this2.selectedInvoices[invoice.id] = true;
          }
        });
      });
    },
    deselectAllInvoicesOfSelectedMonth: function deselectAllInvoicesOfSelectedMonth() {
      var _this3 = this;

      this.monthlyGroupInvoices.forEach(function (monthGroup) {
        monthGroup.invoices.forEach(function (invoice) {
          if (_this3.selectedMonth === monthGroup.month) {
            _this3.selectedInvoices[invoice.id] = false;
          }
        });
      });
    },
    invoiceSelectionChanged: function invoiceSelectionChanged(invoice, monthIndex, event) {
      if (event) {
        console.log('');
      } else {
        this.selectedMonths[monthIndex] = event;
        this.selectedMonth = '';
      }
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    isRowDisabled: function isRowDisabled(invoiceId) {
      return this.disabledInvoice === invoiceId;
    },
    openEmployeeInvoice: function openEmployeeInvoice(id) {
      this.$store.dispatch('openInvoice', id);
    },
    mapYearMonth: function mapYearMonth(yearMonth) {
      var splitted = yearMonth.split('-');
      var date = new Date(splitted[0], splitted[1] - 1);
      return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0];
    },
    isInvoiceSelected: function isInvoiceSelected() {
      return this.selectedInvoices.some(function (element) {
        return element === true;
      });
    },
    getSelectedInvoiceIds: function getSelectedInvoiceIds() {
      return this.selectedInvoices.map(function (value, index) {
        return { id: index, selected: value };
      }).filter(function (element) {
        return element.selected === true;
      }).map(function (element) {
        return element.id;
      });
    },
    bulkDownload: function bulkDownload() {
      if (this.selectedMonth) {
        this.$store.dispatch('bulkEmployeeInvoiceDownloadByMonth', this.selectedMonth);
      } else {
        var selectedInvoiceIds = this.getSelectedInvoiceIds();
        if (selectedInvoiceIds.length === 1) {
          this.openCustomerInvoice(selectedInvoiceIds[0]);
        } else {
          this.$store.dispatch('bulkEmployeeInvoiceDownloadByInvoices', selectedInvoiceIds);
        }
      }
      this.selectedMonth = '';
      this.selectedMonths = [];
      this.selectedInvoices = [];
    },
    listItemLabel1: function listItemLabel1(invoice) {
      if (invoice.type.toUpperCase() === 'EMPLOYEE_INVOICE') {
        return invoice.employee.firstName + ' ' + invoice.employee.lastName;
      }
    },
    listItemLabel2: function listItemLabel2(invoice) {
      if (invoice.type.toUpperCase() === 'EMPLOYEE_INVOICE') {
        return invoice.employee.zipCode + ' ' + invoice.employee.city;
      }
    }
  }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReleaseInvoiceConfirmDialog__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SendInvoiceConfirmDialogue__ = __webpack_require__(545);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomerInvoiceList',
  data: function data() {
    return {
      page: 0,
      size: 50,
      bottom: false,
      disabledInvoice: 0,
      showReleaseInvoiceDialog: false,
      showSendInvoiceDialog: false,
      selectedInvoice: {
        id: 0,
        released: false,
        delivered: false
      },
      editableCustomerInvoices: null,
      selectedMonth: '',
      selectedMonths: [],
      selectedInvoices: [],
      selectedInvoicesToRelease: [],
      selectedInvoicesToSend: []
    };
  },

  components: {
    'release-invoice-dialog': __WEBPACK_IMPORTED_MODULE_0__ReleaseInvoiceConfirmDialog__["a" /* default */],
    'send-invoice-dialog': __WEBPACK_IMPORTED_MODULE_1__SendInvoiceConfirmDialogue__["a" /* default */]
  },
  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        this.page++;
        this.loadCustomerInvoices();
      }
    },
    disabled: function disabled(newValue, oldValue) {
      if (!newValue) {
        this.disabledInvoice = 0;
      }
    },

    monthlyGroupInvoices: {
      deep: true,
      handler: function handler() {
        this.selectAllInvoicesOfSelectedMonth();
      }
    }
  },
  computed: {
    monthlyGroupInvoices: function monthlyGroupInvoices() {
      return this.$store.getters.customerInvoices;
    },
    disabled: function disabled() {
      return this.$store.getters.startDataLoading;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener('scroll', function () {
      _this.bottom = _this.onScroll()();
    });
    this.$store.dispatch('resetCustomerInvoices');
    this.loadCustomerInvoices();
  },

  methods: {
    loadCustomerInvoices: function loadCustomerInvoices() {
      this.$store.dispatch('loadCustomerInvoices', {
        page: this.page,
        size: this.size
      });
    },
    monthSelectionChanged: function monthSelectionChanged(month, event) {
      if (event) {
        this.selectedMonth = month;
        this.selectAllInvoicesOfSelectedMonth();
      } else {
        this.deselectAllInvoicesOfSelectedMonth();
        this.selectedMonth = '';
      }
    },
    selectAllInvoicesOfSelectedMonth: function selectAllInvoicesOfSelectedMonth() {
      var _this2 = this;

      this.monthlyGroupInvoices.forEach(function (monthGroup) {
        monthGroup.invoices.forEach(function (invoice) {
          if (_this2.selectedMonth === monthGroup.month) {
            _this2.selectedInvoices[invoice.id] = true;
          }
        });
      });
    },
    deselectAllInvoicesOfSelectedMonth: function deselectAllInvoicesOfSelectedMonth() {
      var _this3 = this;

      this.monthlyGroupInvoices.forEach(function (monthGroup) {
        monthGroup.invoices.forEach(function (invoice) {
          if (_this3.selectedMonth === monthGroup.month) {
            _this3.selectedInvoices[invoice.id] = false;
          }
        });
      });
    },
    invoiceSelectionChanged: function invoiceSelectionChanged(invoice, monthIndex, event) {
      if (!event) {
        this.selectedMonths[monthIndex] = event;
        this.selectedMonth = '';
      }
    },
    onScroll: function onScroll(e) {
      var scrollY = e.target.scrollTop;
      var visible = e.target.clientHeight;
      var pageHeight = e.target.scrollHeight - 64.0; // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
      var bottomOfPage = visible + scrollY >= pageHeight;
      this.bottom = bottomOfPage || pageHeight < visible;
    },
    isRowDisabled: function isRowDisabled(invoiceId) {
      return this.disabledInvoice === invoiceId;
    },
    isMailDelivered: function isMailDelivered(invoice) {
      return invoice.delivered && invoice.customer.email !== '';
    },
    isMailNotDelivered: function isMailNotDelivered(invoice) {
      return !invoice.delivered && invoice.customer.email !== '';
    },
    openCustomerInvoice: function openCustomerInvoice(id) {
      this.$store.dispatch('openInvoice', id);
    },
    openTurnoverPdf: function openTurnoverPdf(yearMonth) {
      this.$store.dispatch('openTurnover', yearMonth);
    },
    releaseInvoice: function releaseInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.showReleaseInvoiceDialog = true;
    },
    sendInvoice: function sendInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.showSendInvoiceDialog = true;
    },
    closeReleaseInvoiceDialog: function closeReleaseInvoiceDialog() {
      this.showReleaseInvoiceDialog = false;
      this.selectedInvoice = {
        id: 0,
        released: false,
        delivered: false
      };
      this.selectedInvoices = [];
      this.selectedMonths = [];
      this.selectedMonth = '';
    },
    closeReleaseInvoiceDialogAndRetainData: function closeReleaseInvoiceDialogAndRetainData() {
      this.showReleaseInvoiceDialog = false;
    },
    closeSendInvoiceDialog: function closeSendInvoiceDialog() {
      this.showSendInvoiceDialog = false;
      this.selectedInvoice = {
        id: 0,
        released: false,
        delivered: false
      };
      this.selectedInvoices = [];
      this.selectedMonths = [];
      this.selectedMonth = '';
    },
    closeSendInvoiceDialogAndRetainData: function closeSendInvoiceDialogAndRetainData() {
      this.showSendInvoiceDialog = false;
    },
    mapYearMonth: function mapYearMonth(yearMonth) {
      var splitted = yearMonth.split('-');
      var date = new Date(splitted[0], splitted[1] - 1);
      return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0];
    },
    isInvoiceSelected: function isInvoiceSelected() {
      return this.selectedInvoices.some(function (element) {
        return element === true;
      });
    },
    isInvoiceSelectedReleased: function isInvoiceSelectedReleased() {
      if (!this.isInvoiceSelected()) return;
      var selectedInvoices = this.getInvoices(this.getSelectedInvoiceIds());
      return selectedInvoices.some(function (element) {
        return !element.released;
      });
    },
    isInvoiceSendable: function isInvoiceSendable() {
      if (!this.isInvoiceSelected()) return;
      var selectedInvoices = this.getInvoices(this.getSelectedInvoiceIds());
      return selectedInvoices.some(function (element) {
        return element.customer.email && element.released;
      });
    },
    getInvoices: function getInvoices(invoiceIds) {
      if (Array.isArray(invoiceIds) && invoiceIds.length <= 0) return;
      var selectedInvoices = [];
      this.monthlyGroupInvoices.forEach(function (monthGroup) {
        monthGroup.invoices.forEach(function (invoice) {
          if (invoiceIds.includes(invoice.id)) {
            selectedInvoices.push(invoice);
          }
        });
      });
      return selectedInvoices;
    },
    getSelectedInvoiceIds: function getSelectedInvoiceIds() {
      return this.selectedInvoices.map(function (value, index) {
        return { id: index, selected: value };
      }).filter(function (element) {
        return element.selected === true;
      }).map(function (element) {
        return element.id;
      });
    },
    bulkDownload: function bulkDownload() {
      if (this.selectedMonth) {
        this.$store.dispatch('bulkCustomerInvoiceDownloadByMonth', this.selectedMonth);
      } else {
        var selectedInvoiceIds = this.getSelectedInvoiceIds();
        if (selectedInvoiceIds.length === 1) {
          this.openCustomerInvoice(selectedInvoiceIds[0]);
        } else {
          this.$store.dispatch('bulkCustomerInvoiceDownloadByInvoices', selectedInvoiceIds);
        }
      }
      this.selectedMonth = '';
      this.selectedMonths = [];
      this.selectedInvoices = [];
    },
    bulkRelease: function bulkRelease() {
      var selectedInvoiceIds = this.getSelectedInvoiceIds();
      if (selectedInvoiceIds.length === 1) {
        this.selectedInvoice = this.findInvoice(selectedInvoiceIds[0]);
      }
      this.selectedInvoicesToRelease = selectedInvoiceIds;
      this.showReleaseInvoiceDialog = true;
    },
    bulkSend: function bulkSend() {
      var selectedInvoiceIds = this.getSelectedInvoiceIds();
      if (selectedInvoiceIds.length === 1) {
        this.selectedInvoice = this.findInvoice(selectedInvoiceIds[0]);
      }
      this.selectedInvoicesToSend = selectedInvoiceIds;
      this.showSendInvoiceDialog = true;
    },
    findInvoice: function findInvoice(invoiceId) {
      return this.monthlyGroupInvoices.reduce(function (arr, monthGroup) {
        return arr.concat(monthGroup.invoices);
      }, []).find(function (invoice) {
        return invoice.id === invoiceId;
      });
    },
    listItemLabel1: function listItemLabel1(invoice) {
      if (invoice.type.toUpperCase() === 'CUSTOMER_INVOICE') {
        return invoice.customer.lastName + ' ' + invoice.customer.firstName;
      }
    },
    listItemLabel2: function listItemLabel2(invoice) {
      if (invoice.type.toUpperCase() === 'CUSTOMER_INVOICE') {
        return invoice.customer.street + ', ' + invoice.customer.city;
      }
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReleaseInvoiceConfirmDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          released: false,
          type: '',
          customer: {
            lastName: '',
            firstName: ''
          }
        };
      }
    },
    invoices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    yearMonth: {
      type: String,
      default: ''
    }
  },
  methods: {
    mapYearMonth: function mapYearMonth(yearMonth) {
      var splitted = yearMonth.split('-');
      var date = new Date(splitted[0], splitted[1] - 1);
      return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0];
    },
    release: function release() {
      var _this = this;

      if (this.yearMonth) {
        this.$store.dispatch('bulkInvoiceReleaseByMonth', this.yearMonth).finally(function () {
          return _this.$emit('close');
        });
      } else if (this.invoices && this.invoices.length > 1) {
        this.$store.dispatch('bulkInvoiceReleaseByInvoices', this.invoices).finally(function () {
          return _this.$emit('close');
        });
      } else if (this.invoice.id !== 0) {
        this.$store.dispatch('releaseInvoice', this.invoice.id).finally(function () {
          return _this.$emit('close');
        });
      }
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SendInvoiceConfirmDialogue',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          type: '',
          customer: {
            lastName: '',
            firstName: ''
          }
        };
      }
    },
    invoices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    yearMonth: {
      type: String,
      default: ''
    }
  },
  methods: {
    mapYearMonth: function mapYearMonth(yearMonth) {
      var splitted = yearMonth.split('-');
      var date = new Date(splitted[0], splitted[1] - 1);
      return date.toLocaleString('de-de', { month: 'long' }) + ' ' + splitted[0];
    },
    send: function send() {
      var _this = this;

      if (this.yearMonth) {
        this.$store.dispatch('bulkInvoiceSendByMonth', this.yearMonth).finally(function () {
          return _this.$emit('close');
        });
      } else if (this.invoices && this.invoices.length > 1) {
        this.$store.dispatch('bulkInvoiceSendByInvoices', this.invoices).finally(function () {
          return _this.$emit('close');
        });
      } else if (this.invoice.id !== 0) {
        this.$store.dispatch('sendInvoice', this.invoice.id).finally(function () {
          return _this.$emit('close');
        });
      }
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader',
  computed: {
    loading: function loading() {
      return this.$store.getters.dataLoading;
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader_Loader__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_vuetify__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_currency_field__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_currency_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_currency_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_currency_field_dist_index_css__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_currency_field_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_v_currency_field_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(146);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_v_currency_field___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('data-loader', __WEBPACK_IMPORTED_MODULE_3__components_Loader_Loader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  vuetify: __WEBPACK_IMPORTED_MODULE_5__plugins_vuetify__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010940e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010940e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"candora"}},[_c('v-navigation-drawer',{attrs:{"app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,index){return [(_vm.isAllowed(item.allowedRoles))?_c('v-list-item',{key:index,attrs:{"router":"","to":item.link}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n            "+_vm._s(item.lable)+"\n            ")])],1)],1):_vm._e()]})],2)],1),_vm._v(" "),_c('v-app-bar',{staticClass:"primary",attrs:{"app":"","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[(_vm.userIsAdmin)?_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/allTracking","tag":"span"}},[_vm._v("\n        Candora\n      ")]):_vm._e(),_vm._v(" "),(!_vm.userIsAdmin)?_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/myTracking","tag":"span"}},[_vm._v("\n        Candora\n      ")]):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.mdAndUp && this.userIsAuthenticated),expression:"$vuetify.breakpoint.mdAndUp && this.userIsAuthenticated"}],attrs:{"text":"","router":""},on:{"click":_vm.onLogout}},[_vm._v("\n      Abmelden\n      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("logout")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.smAndDown && this.userIsAuthenticated),expression:"$vuetify.breakpoint.smAndDown && this.userIsAuthenticated"}],attrs:{"icon":"","router":""},on:{"click":_vm.onLogout}},[_c('v-icon',[_vm._v("logout")])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"value":_vm.showNotification,"top":true,"multi-line":true,"timeout":5000,"color":_vm.notificationMessage.type}},[_c('div',{staticClass:".title"},[_vm._v(_vm._s(_vm.notificationMessage.title))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","text":""},nativeOn:{"click":function($event){return _vm.closeNotification($event)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-content',[_c('router-view'),_vm._v(" "),_c('data-loader')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ServiceTracking_MyServiceTracking__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ServiceTracking_MyApprovedServiceTracking__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ServiceTracking_AllServiceTracking__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Auth_SignIn__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Auth_SignOut__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Customers_Customers__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Services_Services__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Users_UserManagement__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Invoices_Invoices__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_guard__ = __webpack_require__(550);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  meta: { roles: ['ADMIN', 'USER'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/myTracking',
  name: 'myServiceTracking',
  component: __WEBPACK_IMPORTED_MODULE_2__components_ServiceTracking_MyServiceTracking__["a" /* default */],
  meta: { roles: ['USER'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/myApprovedTracking',
  name: 'MyApprovedServiceTracking',
  component: __WEBPACK_IMPORTED_MODULE_3__components_ServiceTracking_MyApprovedServiceTracking__["a" /* default */],
  meta: { roles: ['USER'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/allTracking',
  name: 'allServiceTracking',
  component: __WEBPACK_IMPORTED_MODULE_4__components_ServiceTracking_AllServiceTracking__["a" /* default */],
  meta: { roles: ['ADMIN'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/customers',
  name: 'customers',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Customers_Customers__["a" /* default */],
  meta: { roles: ['ADMIN'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/services',
  name: 'services',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Services_Services__["a" /* default */],
  meta: { roles: ['ADMIN'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/usermgmt',
  name: 'usermgmt',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Users_UserManagement__["a" /* default */],
  meta: { roles: ['ADMIN'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/invoices',
  name: 'invoices',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Invoices_Invoices__["a" /* default */],
  meta: { roles: ['ADMIN'] },
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}, {
  path: '/signIn',
  name: 'signIn',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Auth_SignIn__["a" /* default */]
}, {
  path: '/signOut',
  name: 'signOut',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Auth_SignOut__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_11__auth_guard__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ routes: routes });

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyServiceTracking_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40edba0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyServiceTracking_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40edba0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyServiceTracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40edba0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyServiceTracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"text":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Neue Zeiterfassung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","disabled":!_vm.submitAllowed,"dark":"","text":""},nativeOn:{"click":function($event){return _vm.createServiceTracking($event)}}},[_c('span',{staticClass:"hidden-xs-only"},[_vm._v("Speichern")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.serviceTrackingForm.valid),callback:function ($$v) {_vm.$set(_vm.serviceTrackingForm, "valid", $$v)},expression:"serviceTrackingForm.valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.customers,"item-value":"id","return-object":"","label":"Kunde","required":"","rules":_vm.mandatoryFieldRule,"append-outer-icon":"help"},on:{"click:append-outer":function($event){_vm.showInfos = !_vm.showInfos}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(data.item.lastName)+" "+_vm._s(data.item.firstName))])],1)]}},{key:"item",fn:function(data){return [_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(data.item.lastName)+" "+_vm._s(data.item.firstName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(data.item.street)+", "+_vm._s(data.item.zipCode)+" "+_vm._s(data.item.city))])],1)]}}]),model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showInfos),callback:function ($$v) {_vm.showInfos=$$v},expression:"showInfos"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Hinweise")])],1),_vm._v(" "),_c('v-card',[(_vm.selectedCustomer && _vm.selectedCustomer.infos)?_c('v-card-text',[_vm._v("\n                    "+_vm._s(_vm.selectedCustomer.infos)+"\n                  ")]):_c('v-card-text',[_vm._v("\n                    Keine Hinweise vorhanden.\n                  ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.services,"item-text":"name","item-value":"id","return-object":"","label":"Dienstleistung","required":"","rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTrackingForm.service),callback:function ($$v) {_vm.$set(_vm.serviceTrackingForm, "service", $$v)},expression:"serviceTrackingForm.service"}},[_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"warning","icon":"warning"}},[_vm._v("\n                  Bitte zuerst einen Kunden auswählen\n                ")])],1)],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Datum auswählen","default-value":_vm.today,"format":"dd.MM.yyyy","value-format":"timestamp","rules":_vm.mandatoryFieldRule,"picker-options":_vm.datePickerOptions},model:{value:(_vm.serviceTrackingForm.date),callback:function ($$v) {_vm.$set(_vm.serviceTrackingForm, "date", $$v)},expression:"serviceTrackingForm.date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('el-time-select',{attrs:{"placeholder":"Startzeit auswählen","format":"HH:mm","value-format":"timestamp","picker-options":_vm.timerPickerOptions,"rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTrackingForm.startTime),callback:function ($$v) {_vm.$set(_vm.serviceTrackingForm, "startTime", $$v)},expression:"serviceTrackingForm.startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('el-time-select',{attrs:{"placeholder":"Endzeit auswählen","format":"HH:mm","value-format":"timestamp","picker-options":{
                start: _vm.timerPickerOptions.start,
                step: _vm.timerPickerOptions.step,
                end: _vm.timerPickerOptions.end,
                minTime: _vm.serviceTrackingForm.startTime
              },"rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTrackingForm.finishTime),callback:function ($$v) {_vm.$set(_vm.serviceTrackingForm, "finishTime", $$v)},expression:"serviceTrackingForm.finishTime"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.submitAllowed,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.createServiceTracking($event)}}},[_vm._v("\n        Speichern\n      ")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"text":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Zeitnachweis bearbeiten")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.sm),expression:"$vuetify.breakpoint.sm"}],attrs:{"text":"","disabled":!_vm.submitAllowed},nativeOn:{"click":function($event){return _vm.updateServiceTracking($event)}}},[_vm._v("\n          Zeitnachweis bearbeiten\n        ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.submitAllowed},nativeOn:{"click":function($event){return _vm.updateServiceTracking($event)}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.customers,"item-value":"id","return-object":"","label":"Kunde","required":"","rules":_vm.mandatoryFieldRule,"append-outer-icon":"help"},on:{"click:append-outer":function($event){_vm.showInfos = !_vm.showInfos}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(data.item.lastName)+" "+_vm._s(data.item.firstName))])],1)]}},{key:"item",fn:function(data){return [_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(data.item.lastName)+" "+_vm._s(data.item.firstName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(data.item.street)+", "+_vm._s(data.item.zipCode)+" "+_vm._s(data.item.city))])],1)]}}]),model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showInfos),callback:function ($$v) {_vm.showInfos=$$v},expression:"showInfos"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Hinweise")])],1),_vm._v(" "),_c('v-card',[(_vm.selectedCustomer && _vm.selectedCustomer.infos)?_c('v-card-text',[_vm._v("\n                      "+_vm._s(_vm.selectedCustomer.infos)+"\n                    ")]):_c('v-card-text',[_vm._v("\n                      Keine Hinweise vorhanden.\n                    ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.services,"item-text":"name","item-value":"id","return-object":"","label":"Dienstleistung","required":"","rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTracking.service),callback:function ($$v) {_vm.$set(_vm.serviceTracking, "service", $$v)},expression:"serviceTracking.service"}},[_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"warning","icon":"warning"}},[_vm._v("\n                    Bitte zuerst einen Kunden auswählen\n                  ")])],1)],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Datum auswählen","format":"dd.MM.yyyy","value-format":"timestamp","rules":_vm.mandatoryFieldRule,"disabled":_vm.disabledDate(_vm.serviceTracking.date)},model:{value:(_vm.serviceTracking.date),callback:function ($$v) {_vm.$set(_vm.serviceTracking, "date", $$v)},expression:"serviceTracking.date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('el-time-select',{attrs:{"placeholder":"Startzeit auswählen","format":"HH:mm","value-format":"timestamp","picker-options":_vm.timerPickerOptions,"rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTracking.startTime),callback:function ($$v) {_vm.$set(_vm.serviceTracking, "startTime", $$v)},expression:"serviceTracking.startTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('el-time-select',{attrs:{"placeholder":"Endzeit auswählen","format":"HH:mm","value-format":"timestamp","picker-options":{
                  start: _vm.timerPickerOptions.start,
                  step: _vm.timerPickerOptions.step,
                  end: _vm.timerPickerOptions.end,
                  minTime: _vm.serviceTracking.startTime
                },"rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceTracking.finishTime),callback:function ($$v) {_vm.$set(_vm.serviceTracking, "finishTime", $$v)},expression:"serviceTracking.finishTime"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.submitAllowed,"loading":_vm.loading,"color":"primary","text":""},on:{"click":_vm.updateServiceTracking}},[_vm._v("\n        Speichern\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(146);






var userService = {
  login: login,
  logout: logout,
  fetchUserData: fetchUserData,
  searchUsers: searchUsers,
  getAllRoles: getAllRoles,
  createUser: createUser,
  updateUser: updateUser,
  deleteUser: deleteUser
};

function fetchUserData(user) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://api.candora-services.de" + '/api/user/' + user.id, config()).then(function (userDetails) {
    var currentUser = {
      id: user.id,
      username: user.username,
      role: user.role,
      token: user.token,
      customers: userDetails.data.customers
    };
    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentUser));
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].commit('setUser', currentUser);
  });
}

function login(username, password) {
  var _this = this;

  var requestOptions = {
    headers: { 'Content-Type': 'application/json' }
  };

  var requestBody = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'username': username, 'password': password });

  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.candora-services.de" + '/login', requestBody, requestOptions).then(handleLogin).then(function (user) {
    if (user) {
      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));

      _this.fetchUserData(user).then(function () {
        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].dispatch('showNotification', {
          title: 'Herzlich Willkommen',
          type: 'primary'
        });
      }).catch(function (error) {
        return console.log(error);
      });
    }
  });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].commit('setUser', null);
}

function searchUsers(searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.candora-services.de" + '/api/user/search?page=' + page + '&size=' + size, searchTerms, config());
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.candora-services.de" + '/api/user/search', searchTerms, config());
  }
}

function getAllRoles() {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://api.candora-services.de" + '/api/role', config());
}

function createUser(userForm) {
  var newUser = {
    email: userForm.email,
    password: userForm.password,
    pwIsInitial: true,
    role: userForm.role,
    customers: userForm.customers,
    firstName: userForm.firstName,
    lastName: userForm.lastName,
    street: userForm.street,
    city: userForm.city,
    zipCode: userForm.zipCode
  };

  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.candora-services.de" + '/api/user', newUser, config());
}

function updateUser(user) {
  var newUser = {
    id: user.id,
    email: user.email,
    password: user.password,
    pwIsInitial: user.password !== null,
    role: user.role,
    customers: user.customers,
    firstName: user.firstName,
    lastName: user.lastName,
    street: user.street,
    city: user.city,
    zipCode: user.zipCode
  };
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put("https://api.candora-services.de" + '/api/user/' + newUser.id, newUser, config());
}

function deleteUser(id) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete("https://api.candora-services.de" + '/api/user/' + id, config());
}

function handleLogin(response) {
  if (response.status !== 200) {
    if (response.status === 401) {
      logout();
      location.reload(true);
    }
  }
  if (response.headers.authorization) {
    var bearer = response.headers.authorization;
    var token = bearer.substring(7, bearer.length);
    var decoded = __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.decode(token);

    return { 'id': decoded.userId, 'username': decoded.sub, 'role': decoded.role.replace(/ROLE_/g, ''), 'token': token };
  }
}

function config() {
  return { headers: Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* authHeader */])() };
}

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authHeader;
function authHeader() {
  // return authorization header with jwt token
  var user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'Authorization': 'Bearer ' + user.token };
  } else {
    return {};
  }
}

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.4","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.6.0","mocha":"^6.1.4"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    maxUsers: 10,
    myCustomers: [],
    allUsers: [],
    roles: [],
    loginFailed: false
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setRoles: function setRoles(state, payload) {
      state.roles = payload;
    },
    setEditedUser: function setEditedUser(state, payload) {
      var foundIndex = state.allUsers.findIndex(function (user) {
        return user.id === payload.id;
      });
      if (foundIndex > -1) state.allUsers.splice(foundIndex, 1, payload);
    },
    setUsers: function setUsers(state, payload) {
      state.allUsers = payload;
    },
    addUser: function addUser(state, payload) {
      if (state.allUsers.length === state.maxUsers) {
        state.allUsers.push(payload);
        state.maxUsers += 1;
      }
    },
    addUsers: function addUsers(state, payload) {
      if (state.allUsers.length <= state.maxUsers - payload.length) {
        state.allUsers = state.allUsers.concat(payload);
      }
    },
    removeUser: function removeUser(state, payload) {
      var foundIndex = state.allUsers.findIndex(function (user) {
        return user.id === payload;
      });
      if (foundIndex > -1) {
        state.allUsers.splice(foundIndex, 1);
        state.maxUsers -= 1;
      }
    },
    setMaxUsers: function setMaxUsers(state, payload) {
      state.maxUsers = payload;
    },
    setLoginFailed: function setLoginFailed(state, payload) {
      state.loginFailed = payload;
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state;

      commit('setLoginFailed', false);
      dispatch('startLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].login(payload.email, payload.password).then(function () {
        return commit('setLoginFailed', false);
      }).catch(function (error) {
        commit('setLoginFailed', true);
        dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading', false);
      });
    },
    signUserOut: function signUserOut() {
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].logout();
    },
    loadRoles: function loadRoles(_ref2) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].getAllRoles().then(function (response) {
        commit('setRoles', response.data);
      }).catch(function (error) {
        return dispatch('handleError', error);
      });
    },
    loadUserData: function loadUserData(_ref3, user) {
      var dispatch = _ref3.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].fetchUserData(user).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    loadUsers: function loadUsers(_ref4, filter) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].searchUsers(filter.searchTerms, filter.page, filter.size).then(function (response) {
        commit('setMaxUsers', response.data.totalElements);
        commit('addUsers', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    resetUsers: function resetUsers(_ref5) {
      var commit = _ref5.commit;

      commit('setUsers', []);
      commit('setMaxUsers', 10);
    },
    logout: function logout(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].logout();
    },
    addUser: function addUser(_ref7, user) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].createUser(user).then(function (response) {
        commit('addUser', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich angelegt.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    editUser: function editUser(_ref8, user) {
      var dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].updateUser(user).then(function (response) {
        commit('setEditedUser', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich geändert.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    deleteUser: function deleteUser(_ref9, userId) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["e" /* userService */].deleteUser(userId).then(function () {
        commit('removeUser', userId);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Mitarbeiter erfolgreich gelöscht.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    allUsers: function allUsers(state) {
      return state.allUsers;
    },
    maxUsers: function maxUsers(state) {
      return state.maxUsers;
    },
    roles: function roles(state) {
      return state.roles;
    },
    loginFailed: function loginFailed(state) {
      return state.loginFailed;
    }
  }
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    services: [],
    maxServices: 50
  },
  mutations: {
    setServices: function setServices(state, payload) {
      state.services = payload;
    },
    setEditedService: function setEditedService(state, payload) {
      var foundIndex = state.services.findIndex(function (service) {
        return service.id === payload.id;
      });
      state.services.splice(foundIndex, 1, payload);
    },
    addService: function addService(state, payload) {
      if (state.services.length === state.maxServices) {
        state.services.push(payload);
        state.maxServices += 1;
      }
    },
    addServices: function addServices(state, payload) {
      if (state.services.length <= state.maxServices - payload.length) {
        state.services = state.services.concat(payload);
      }
    },
    removeService: function removeService(state, payload) {
      var foundIndex = state.services.findIndex(function (service) {
        return service.id === payload;
      });
      if (foundIndex > -1) {
        state.services.splice(foundIndex, 1);
        state.maxServices -= 1;
      }
    },
    setMaxServices: function setMaxServices(state, payload) {
      state.maxServices = payload;
    }
  },
  actions: {
    loadServices: function loadServices(_ref, filter) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["c" /* serviceService */].searchServices(filter.searchTerms, filter.page, filter.size).then(function (response) {
        commit('setMaxServices', response.data.totalElements);

        var mappedServices = response.data.content.map(function (service) {
          return {
            id: service.id,
            name: service.name,
            privateHourFee: service.privateHourFee,
            businessHourFee: service.businessHourFee
          };
        });

        commit('addServices', mappedServices);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    resetServices: function resetServices(_ref2) {
      var commit = _ref2.commit;

      commit('setServices', []);
      commit('setMaxServices', 50);
    },
    addService: function addService(_ref3, service) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["c" /* serviceService */].createService(service).then(function (response) {
        commit('addService', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich angelegt.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    editService: function editService(_ref4, service) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["c" /* serviceService */].updateService(service).then(function (response) {
        commit('editService', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich geändert.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    deleteService: function deleteService(_ref5, serviceId) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["c" /* serviceService */].deleteService(serviceId).then(function (response) {
        commit('removeService', serviceId);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich gelöscht.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    }
  },
  getters: {
    services: function services(state) {
      return state.services;
    },
    maxServices: function maxServices(state) {
      return state.maxServices;
    }
  }
});

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    customers: [],
    maxCustomers: 10
  },
  mutations: {
    setCustomers: function setCustomers(state, payload) {
      state.customers = payload;
    },
    setEditedCustomer: function setEditedCustomer(state, payload) {
      var foundIndex = state.customers.findIndex(function (customer) {
        return customer.id === payload.id;
      });
      if (foundIndex > -1) state.customers.splice(foundIndex, 1, payload);
    },
    addCustomer: function addCustomer(state, payload) {
      if (state.customers.length === state.maxCustomers) {
        state.customers.push(payload);
        state.maxCustomers += 1;
      }
    },
    addCustomers: function addCustomers(state, payload) {
      if (state.customers.length <= state.maxCustomers - payload.length) {
        state.customers = state.customers.concat(payload);
      }
    },
    setMaxCustomers: function setMaxCustomers(state, payload) {
      state.maxCustomers = payload;
    },
    removeCustomer: function removeCustomer(state, payload) {
      var foundIndex = state.customers.findIndex(function (customer) {
        return customer.id === payload;
      });
      if (foundIndex > -1) {
        state.customers.splice(foundIndex, 1);
        state.maxCustomers -= 1;
      }
    }
  },
  actions: {
    loadCustomers: function loadCustomers(_ref, filter) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["a" /* customerService */].searchCustomers(filter.searchTerms, filter.page, filter.size).then(function (response) {
        commit('setMaxCustomers', response.data.totalElements);
        commit('addCustomers', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    resetCustomers: function resetCustomers(_ref2) {
      var commit = _ref2.commit;

      commit('setCustomers', []);
      commit('setMaxCustomers', 10);
    },
    addCustomer: function addCustomer(_ref3, customer) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["a" /* customerService */].createCustomer(customer).then(function (response) {
        commit('addCustomer', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Kunde erfolgreich angelegt.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    editCustomer: function editCustomer(_ref4, customer) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["a" /* customerService */].updateCustomer(customer).then(function (response) {
        commit('setEditedCustomer', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Kunde erfolgreich geändert.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    removeCustomer: function removeCustomer(_ref5, customerId) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["a" /* customerService */].deleteCustomer(customerId).then(function (response) {
        commit('removeCustomer', customerId);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Kunde erfolgreich gelöscht.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    }
  },
  getters: {
    customers: function customers(state) {
      return state.customers;
    },
    maxCustomers: function maxCustomers(state) {
      return state.maxCustomers;
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    showNotification: false,
    notificationMessage: {
      text: '',
      type: ''
    }
  },
  mutations: {
    setShowNotification: function setShowNotification(state, payload) {
      state.showNotification = payload;
    },
    setNotificationMessage: function setNotificationMessage(state, payload) {
      state.notificationMessage = payload;
    }
  },
  actions: {
    showNotification: function showNotification(_ref, payload) {
      var commit = _ref.commit;

      commit('setShowNotification', false);
      setTimeout(function () {
        commit('setShowNotification', true);
        commit('setNotificationMessage', payload);
      }, 100);
    }
  },
  getters: {
    showNotification: function showNotification(state) {
      return state.showNotification;
    },
    notificationMessage: function notificationMessage(state) {
      return state.notificationMessage;
    }
  }
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    myServiceTrackings: [],
    myApprovedServiceTrackings: [],
    allServiceTrackings: [],
    maxServiceTrackings: 50,
    maxApprovedServiceTrackings: 50
  },
  mutations: {
    setMyServiceTrackings: function setMyServiceTrackings(state, payload) {
      state.myServiceTrackings = payload;
    },
    setMyApprovedServiceTrackings: function setMyApprovedServiceTrackings(state, payload) {
      state.myApprovedServiceTrackings = payload;
    },
    setEditedServiceTrackingOfMy: function setEditedServiceTrackingOfMy(state, payload) {
      var foundIndex = state.myServiceTrackings.findIndex(function (servieTracking) {
        return servieTracking.id === payload.id;
      });
      if (foundIndex > -1) state.myServiceTrackings.splice(foundIndex, 1, payload);
    },
    setAllServiceTrackings: function setAllServiceTrackings(state, payload) {
      state.allServiceTrackings = payload;
    },
    setEditedServiceTrackingOfAll: function setEditedServiceTrackingOfAll(state, payload) {
      state.allServiceTrackings.forEach(function (serviceTrackingMonth) {
        serviceTrackingMonth.userGroupedServiceTrackings.forEach(function (serviceTrackingssOfUsers) {
          var foundIndex = serviceTrackingssOfUsers.usersServiceTracking.findIndex(function (servieTracking) {
            return servieTracking.id === payload.id;
          });
          if (foundIndex > -1) serviceTrackingssOfUsers.usersServiceTracking.splice(foundIndex, 1, payload);
        });
      });
    },
    addMyServiceTracking: function addMyServiceTracking(state, payload) {
      if (state.myServiceTrackings.length === state.maxServiceTrackings) {
        state.myServiceTrackings.push(payload);
        state.maxServiceTrackings += 1;
      }
    },
    addMyServiceTrackings: function addMyServiceTrackings(state, payload) {
      if (state.myServiceTrackings.length <= state.maxServiceTrackings - payload.length) {
        payload.forEach(function (newServiceTracking) {
          return state.myServiceTrackings.push(newServiceTracking);
        });
      }
    },
    addMyApprovedServiceTrackings: function addMyApprovedServiceTrackings(state, payload) {
      if (state.maxApprovedServiceTrackings >= payload.length) {
        state.myApprovedServiceTrackings = state.myApprovedServiceTrackings.concat(payload);
      }
    },
    addAllServiceTrackings: function addAllServiceTrackings(state, payload) {
      if (state.allServiceTrackings.length <= state.maxServiceTrackings - payload.length) {
        // Month level
        payload.forEach(function (responseMonth) {
          if (state.allServiceTrackings.length === 0) {
            state.allServiceTrackings.push(responseMonth);
          } else {
            var wasDateModified = false;
            state.allServiceTrackings.forEach(function (currentMonth) {
              // User group level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.userGroupedServiceTrackings.forEach(function (value) {
                  var wasAdded = false;
                  currentMonth.userGroupedServiceTrackings.forEach(function (currentGroup) {
                    if (value.userId === currentGroup.userId) {
                      value.usersServiceTracking.forEach(function (tracking) {
                        return currentGroup.usersServiceTracking.push(tracking);
                      });
                      wasAdded = true;
                      wasDateModified = true;
                    }
                  });
                  if (!wasAdded) {
                    currentMonth.userGroupedServiceTrackings.push(value);
                    wasDateModified = true;
                  }
                });
              }
            });
            if (!wasDateModified) {
              state.allServiceTrackings.push(responseMonth);
            }
          }
        });
      }
    },
    setMaxServiceTrackings: function setMaxServiceTrackings(state, payload) {
      state.maxServiceTrackings = payload;
    },
    setMaxApprovedServiceTrackings: function setMaxApprovedServiceTrackings(state, payload) {
      state.maxApprovedServiceTrackings = payload;
    },
    removeServiceTrackingOfAll: function removeServiceTrackingOfAll(state, payload) {
      state.allServiceTrackings.forEach(function (serviceTrackingMonth, monthIndex) {
        serviceTrackingMonth.userGroupedServiceTrackings.forEach(function (serviceTrackingssOfUsers, userIndex) {
          var foundIndex = serviceTrackingssOfUsers.usersServiceTracking.findIndex(function (servieTracking) {
            return servieTracking.id === payload;
          });
          if (foundIndex > -1) {
            serviceTrackingssOfUsers.usersServiceTracking.splice(foundIndex, 1);
            if (serviceTrackingssOfUsers.usersServiceTracking.length === 0) {
              serviceTrackingMonth.userGroupedServiceTrackings.splice(userIndex, 1);
            }
          }
        });
        if (serviceTrackingMonth.userGroupedServiceTrackings.length === 0) {
          state.allServiceTrackings.splice(monthIndex, 1);
        }
      });
    },
    removeServiceTrackingFromMyApproved: function removeServiceTrackingFromMyApproved(state, payload) {
      var foundIndex = state.myApprovedServiceTrackings.findIndex(function (servieTracking) {
        return servieTracking.id === payload.id;
      });
      if (foundIndex > -1) state.myApprovedServiceTrackings.splice(foundIndex, 1);
    }
  },
  actions: {
    loadMyServicesTrackings: function loadMyServicesTrackings(_ref, filter) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].getMyServicesTrackings(filter.page, filter.size, false).then(function (response) {
        commit('setMaxServiceTrackings', response.data.totalElements);
        commit('addMyServiceTrackings', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    loadMyApprovedServicesTrackings: function loadMyApprovedServicesTrackings(_ref2, filter) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].getMyServicesTrackings(filter.page, filter.size, true).then(function (response) {
        commit('setMaxServiceTrackings', response.data.totalElements);
        commit('addMyApprovedServiceTrackings', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    loadAllServicesTrackings: function loadAllServicesTrackings(_ref3, filter) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].getAllServicesTrackings(filter.page, filter.size).then(function (response) {
        commit('setMaxApprovedServiceTrackings', response.data.totalElements);
        commit('addAllServiceTrackings', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    approveServiceTracking: function approveServiceTracking(_ref4, serviceTracking) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].approveServiceTracking(serviceTracking.id).then(function () {
        return commit('removeServiceTrackingOfAll', serviceTracking.id);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Zeiterfassung erfolgreich genehmigt.',
          type: 'primary'
        });
      }).catch(function (error) {
        serviceTracking.approved = false;
        commit('setEditedServiceTrackingOfAll', serviceTracking);
        dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    resetServiceTrackings: function resetServiceTrackings(_ref5) {
      var commit = _ref5.commit;

      commit('setMyServiceTrackings', []);
      commit('setAllServiceTrackings', []);
      commit('setMaxServiceTrackings', 50);
    },
    resetApprovedServiceTrackings: function resetApprovedServiceTrackings(_ref6) {
      var commit = _ref6.commit;

      commit('setMyApprovedServiceTrackings', []);
      commit('setMaxApprovedServiceTrackings', 60);
    },
    addServiceTracking: function addServiceTracking(_ref7, serviceTracking) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].createServiceTracking(serviceTracking).then(function (response) {
        commit('addMyServiceTracking', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Zeitnachweis erfolgreich angelegt.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    },
    updateServiceTrackingOfMy: function updateServiceTrackingOfMy(_ref8, serviceTracking) {
      var dispatch = _ref8.dispatch,
          commit = _ref8.commit,
          rootState = _ref8.rootState;

      dispatch('startLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* serviceTrackingService */].updateServiceTracking(serviceTracking).then(function (response) {
        if (rootState.user.user.role === 'ADMIN') {
          commit('setEditedServiceTrackingOfAll', response.data);
        } else {
          commit('removeServiceTrackingFromMyApproved', response.data);
          commit('setEditedServiceTrackingOfMy', response.data);
        }
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Zeitnachweis erfolgreich geändert.',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopLoading');
      });
    }
  },
  getters: {
    myServiceTrackings: function myServiceTrackings(state) {
      return state.myServiceTrackings;
    },
    myApprovedServiceTrackings: function myApprovedServiceTrackings(state) {
      return state.myApprovedServiceTrackings;
    },
    allServiceTrackings: function allServiceTrackings(state) {
      return state.allServiceTrackings;
    },
    maxServiceTrackings: function maxServiceTrackings(state) {
      return state.maxServiceTrackings;
    }
  }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    employeeInvoices: [],
    customerInvoices: [],
    maxEmployeeInvoices: 10,
    maxCustomerInvoices: 10
  },
  mutations: {
    setEmployeeInvoices: function setEmployeeInvoices(state, payload) {
      state.employeeInvoices = payload;
    },
    setCustomerInvoices: function setCustomerInvoices(state, payload) {
      state.customerInvoices = payload;
    },
    setMaxEmployeeInvoices: function setMaxEmployeeInvoices(state, payload) {
      state.maxEmployeeInvoices = payload;
    },
    setMaxCustomerInvoices: function setMaxCustomerInvoices(state, payload) {
      state.maxCustomerInvoices = payload;
    },
    setCustomerInvoice: function setCustomerInvoice(state, payload) {
      state.customerInvoices.forEach(function (group) {
        var foundIndex = group.invoices.findIndex(function (customerInvoice) {
          return customerInvoice.id === payload.id;
        });
        if (foundIndex > -1) group.invoices.splice(foundIndex, 1, payload);
      });
    },
    addEmployeeInvoices: function addEmployeeInvoices(state, payload) {
      if (state.employeeInvoices.length <= state.maxEmployeeInvoices - payload.length) {
        // Month level
        payload.forEach(function (responseMonth) {
          if (state.employeeInvoices.length === 0) {
            state.employeeInvoices.push(responseMonth);
          } else {
            var wasDateModified = false;
            state.employeeInvoices.forEach(function (currentMonth) {
              // Invoices level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.invoices.forEach(function (tracking) {
                  return currentMonth.invoices.push(tracking);
                });
                wasDateModified = true;
              }
            });
            if (!wasDateModified) {
              state.employeeInvoices.push(responseMonth);
            }
          }
        });
      }
    },
    addCustomerInvoices: function addCustomerInvoices(state, payload) {
      if (state.customerInvoices.length <= state.maxCustomerInvoices - payload.length) {
        // Month level
        payload.forEach(function (responseMonth) {
          if (state.customerInvoices.length === 0) {
            state.customerInvoices.push(responseMonth);
          } else {
            var wasDateModified = false;
            state.customerInvoices.forEach(function (currentMonth) {
              // Invoices level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.invoices.forEach(function (tracking) {
                  return currentMonth.invoices.push(tracking);
                });
                wasDateModified = true;
              }
            });
            if (!wasDateModified) {
              state.customerInvoices.push(responseMonth);
            }
          }
        });
      }
    }
  },
  actions: {
    loadEmployeeInvoices: function loadEmployeeInvoices(_ref, filter) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getEmployeeInvoices(filter.page, filter.size).then(function (response) {
        commit('setMaxEmployeeInvoices', response.data.totalElements);
        commit('addEmployeeInvoices', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    loadCustomerInvoices: function loadCustomerInvoices(_ref2, filter) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getCustomerInvoices(filter.page, filter.size).then(function (response) {
        commit('setMaxCustomerInvoices', response.data.totalElements);
        commit('addCustomerInvoices', response.data.content);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    openInvoice: function openInvoice(_ref3, invoiceId) {
      var dispatch = _ref3.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getInvoice(invoiceId).then(function (response) {
        return dispatch('handlePdfDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      });
    },
    openTurnover: function openTurnover(_ref4, month) {
      var dispatch = _ref4.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getTurnover(month).then(function (response) {
        return dispatch('handlePdfDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      });
    },
    releaseInvoice: function releaseInvoice(_ref5, invoiceId) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].releaseInvoice(invoiceId).then(function (response) {
        commit('setCustomerInvoice', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Abrechnung erfolgreich veröffentlicht',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    sendInvoice: function sendInvoice(_ref6, invoiceId) {
      var dispatch = _ref6.dispatch,
          commit = _ref6.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].sendInvoice(invoiceId).then(function (response) {
        commit('setCustomerInvoice', response.data);
      }).then(function () {
        return dispatch('showNotification', {
          title: 'Abrechnung erfolgreich versendet',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkCustomerInvoiceDownloadByInvoices: function bulkCustomerInvoiceDownloadByInvoices(_ref7, invoiceIds) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getCustomerInvoicesByInvoices(invoiceIds).then(function (response) {
        return dispatch('handleZipDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkEmployeeInvoiceDownloadByInvoices: function bulkEmployeeInvoiceDownloadByInvoices(_ref8, invoiceIds) {
      var dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getEmployeeInvoicesByInvoices(invoiceIds).then(function (response) {
        return dispatch('handleZipDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkCustomerInvoiceDownloadByMonth: function bulkCustomerInvoiceDownloadByMonth(_ref9, month) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getCustomerInvoicesByMonth(month).then(function (response) {
        return dispatch('handleZipDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkEmployeeInvoiceDownloadByMonth: function bulkEmployeeInvoiceDownloadByMonth(_ref10, month) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].getEmployeeInvoicesByMonth(month).then(function (response) {
        return dispatch('handleZipDownload', response);
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkInvoiceReleaseByInvoices: function bulkInvoiceReleaseByInvoices(_ref11, invoiceIds) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].releaseInvoicesByInvoices(invoiceIds).then(function (response) {
        response.data.forEach(function (invoice) {
          return commit('setCustomerInvoice', invoice);
        });
        dispatch('showNotification', {
          title: response.data.length + ' Abrechnung(en) erfolgreich veröffentlicht',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkInvoiceReleaseByMonth: function bulkInvoiceReleaseByMonth(_ref12, month) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].releaseInvoicesByMonth(month).then(function (response) {
        response.data.forEach(function (invoice) {
          return commit('setCustomerInvoice', invoice);
        });
        dispatch('showNotification', {
          title: response.data.length + ' Abrechnung(en) erfolgreich veröffentlicht',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkInvoiceSendByInvoices: function bulkInvoiceSendByInvoices(_ref13, invoiceIds) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].sendInvoicesByInvoices(invoiceIds).then(function (response) {
        response.data.forEach(function (invoice) {
          return commit('setCustomerInvoice', invoice);
        });
        dispatch('showNotification', {
          title: response.data.length + ' Abrechnungen erfolgreich versendet',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    bulkInvoiceSendByMonth: function bulkInvoiceSendByMonth(_ref14, month) {
      var dispatch = _ref14.dispatch,
          commit = _ref14.commit;

      dispatch('startDataLoading');
      __WEBPACK_IMPORTED_MODULE_0__services__["b" /* invoiceService */].sendInvoicesByMonth(month).then(function (response) {
        response.data.forEach(function (invoice) {
          return commit('setCustomerInvoice', invoice);
        });
        dispatch('showNotification', {
          title: response.data.length + ' Abrechnungen erfolgreich versendet',
          type: 'primary'
        });
      }).catch(function (error) {
        return dispatch('handleError', error);
      }).finally(function () {
        return dispatch('stopDataLoading');
      });
    },
    resetEmployerInvoices: function resetEmployerInvoices(_ref15) {
      var commit = _ref15.commit;

      commit('setEmployeeInvoices', []);
      commit('setMaxEmployeeInvoices', 10);
    },
    resetCustomerInvoices: function resetCustomerInvoices(_ref16) {
      var commit = _ref16.commit;

      commit('setCustomerInvoices', []);
      commit('setMaxCustomerInvoices', 10);
    },
    handlePdfDownload: function handlePdfDownload(_ref17, response) {
      var dispatch = _ref17.dispatch,
          commit = _ref17.commit;

      var a = document.createElement('a');
      document.body.appendChild(a);
      var blob = new Blob([response.data], { type: 'application/pdf' });
      var url = URL.createObjectURL(blob);
      a.style = 'display: none';
      a.href = url;

      var filename = '';
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(response.request.getResponseHeader('Content-Disposition'));
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }

      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    handleZipDownload: function handleZipDownload(_ref18, response) {
      var dispatch = _ref18.dispatch,
          commit = _ref18.commit;

      var a = document.createElement('a');
      document.body.appendChild(a);
      var blob = new Blob([response.data], { type: 'application/zip' });
      var url = URL.createObjectURL(blob);
      a.style = 'display: none';
      a.href = url;
      var filename = '';
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(response.request.getResponseHeader('Content-Disposition'));
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  },
  getters: {
    employeeInvoices: function employeeInvoices(state) {
      return state.employeeInvoices;
    },
    customerInvoices: function customerInvoices(state) {
      return state.customerInvoices;
    }
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    error: {}
  },
  mutations: {
    setError: function setError(state, payload) {
      state.error = payload;
    }
  },
  actions: {
    handleError: function handleError(_ref, payload) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      commit('setError', payload);
      if (payload.message === 'Network Error') {
        dispatch('showNotification', {
          title: 'Sie haben keine Verbingung!',
          type: 'error'
        });
        return;
      }
      if (payload.response.status === 401 || payload.response.status === 403) {
        dispatch('logout');
      } else {
        dispatch('showNotification', {
          title: payload.response.data.message,
          type: 'error'
        });
      }
    }
  }
});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var serviceService = {
  searchServices: searchServices,
  createService: createService,
  getService: getService,
  updateService: updateService,
  deleteService: deleteService
};

function createService(service) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/service', service, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getService(serviceId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/service/' + serviceId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function updateService(service) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("https://api.candora-services.de" + '/api/service/' + service.id, service, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function deleteService(serviceId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("https://api.candora-services.de" + '/api/service/' + serviceId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function searchServices(searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/service/search?page=' + page + '&size=' + size, searchTerms, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/service/search', searchTerms, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
  }
}

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var customerService = {
  searchCustomers: searchCustomers,
  createCustomer: createCustomer,
  getCustomer: getCustomer,
  updateCustomer: updateCustomer,
  deleteCustomer: deleteCustomer
};

function createCustomer(customer) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/customer', customer, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getCustomer(customerId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/customer/' + customerId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function updateCustomer(customer) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("https://api.candora-services.de" + '/api/customer/' + customer.id, customer, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function deleteCustomer(customerId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("https://api.candora-services.de" + '/api/customer/' + customerId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function searchCustomers(searchTerms, page, size) {
  if (page !== undefined && size !== undefined) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/customer/search?page=' + page + '&size=' + size, searchTerms, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/customer/search', searchTerms, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
  }
}

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceTrackingService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var serviceTrackingService = {
  approveServiceTracking: approveServiceTracking,
  getAllServicesTrackings: getAllServicesTrackings,
  getMyServicesTrackings: getMyServicesTrackings,
  createServiceTracking: createServiceTracking,
  getServiceTracking: getServiceTracking,
  updateServiceTracking: updateServiceTracking,
  deleteServiceTracking: deleteServiceTracking
};

function getAllServicesTrackings(page, size) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/tracking/searchAll?page=' + page + '&size=' + size, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getMyServicesTrackings(page, size, approved) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/tracking/searchUser?page=' + page + '&size=' + size + '&approved=' + approved, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function createServiceTracking(serviceTracking) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/tracking', serviceTracking, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getServiceTracking(serviceTrackingId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/tracking/' + serviceTrackingId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function updateServiceTracking(service) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("https://api.candora-services.de" + '/api/tracking/' + service.id, service, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function deleteServiceTracking(serviceTrackingId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("https://api.candora-services.de" + '/api/tracking/' + serviceTrackingId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function approveServiceTracking(serviceTrackingId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/tracking/' + serviceTrackingId + '/approve', null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invoiceService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var invoiceService = {
  getInvoice: getInvoice,
  getEmployeeInvoices: getEmployeeInvoices,
  getCustomerInvoices: getCustomerInvoices,
  getEmployeeInvoicesByInvoices: getEmployeeInvoicesByInvoices,
  getCustomerInvoicesByInvoices: getCustomerInvoicesByInvoices,
  getEmployeeInvoicesByMonth: getEmployeeInvoicesByMonth,
  getCustomerInvoicesByMonth: getCustomerInvoicesByMonth,
  releaseInvoice: releaseInvoice,
  releaseInvoicesByInvoices: releaseInvoicesByInvoices,
  releaseInvoicesByMonth: releaseInvoicesByMonth,
  sendInvoice: sendInvoice,
  sendInvoicesByInvoices: sendInvoicesByInvoices,
  sendInvoicesByMonth: sendInvoicesByMonth,
  getTurnover: getTurnover
};

function getInvoice(invoiceId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/invoices/' + invoiceId, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

function getEmployeeInvoices(page, size) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/invoices/employee?lastMonthsToShow=4' + '&page=' + page + '&size=' + size, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getCustomerInvoices(page, size) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/invoices/customer?lastMonthsToShow=4' + '&page=' + page + '&size=' + size, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getEmployeeInvoicesByInvoices(invoiceIds) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/employee/bulk', invoiceIds, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

function getCustomerInvoicesByInvoices(invoiceIds) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/customer/bulk', invoiceIds, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

function getEmployeeInvoicesByMonth(month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/employee/bulk/' + month, null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

function getCustomerInvoicesByMonth(month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/customer/bulk/' + month, null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

function releaseInvoice(invoiceId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/' + invoiceId + '/release', null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function releaseInvoicesByInvoices(invoiceIds) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/bulk/release', invoiceIds, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function releaseInvoicesByMonth(month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/bulk/release/' + month, null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function sendInvoice(invoiceId) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/' + invoiceId + '/send-mail', null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function sendInvoicesByInvoices(invoiceIds) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/bulk/send-mail', invoiceIds, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function sendInvoicesByMonth(month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api.candora-services.de" + '/api/invoices/bulk/send-mail/' + month, null, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])() });
}

function getTurnover(month) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://api.candora-services.de" + '/api/invoices/bulk/turnover/' + month, { headers: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* authHeader */])(), responseType: 'blob' });
}

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zeitnachweis löschen")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("\n        Sie möchten diesen Zeitnachweis wirklich löschen?\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":_vm.deleteServiceTracking}},[_vm._v("\n          Löschen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zeitnachweis genehmigen")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("\n        Sie möchten diesen Zeitnachweis wirklich genehmigen?\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":_vm.closeApproveDialog}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.approveServiceTracking}},[_vm._v("\n          Genehmigen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 60px)"},attrs:{"id":"myTrackings"}},[_c('v-list',{directives:[{name:"scroll",rawName:"v-scroll:#myTrackings",value:(_vm.onScroll),expression:"onScroll",arg:"#myTrackings"}],attrs:{"two-line":""}},[_vm._l((_vm.myTrackings),function(tracking,index){return [_c('v-list-item',{key:index},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(tracking.customer.firstName)+" "+_vm._s(tracking.customer.lastName))]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"hidden-xs-and-down"},[_vm._v(_vm._s(tracking.customer.street)+", "+_vm._s(tracking.customer.city))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.getDate(tracking.startTime))+": "+_vm._s(_vm.getTime(tracking.startTime))+"-"+_vm._s(_vm.getTime(tracking.finishTime)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(tracking.service.name))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditServiceTracking(tracking)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteServiceTracking(tracking)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1),_vm._v(" "),(index + 1 < _vm.myTrackings.length)?_c('v-divider',{key:'divider-'+index}):_vm._e()]})],2)],1),_vm._v(" "),_c('data-loader'),_vm._v(" "),_c('new-tracking-dialog',{attrs:{"show":_vm.showNewServiceTrackingDialog},on:{"close":_vm.closeNewServiceTracking}}),_vm._v(" "),_c('edit-service-tracking-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showEditServiceTrackingDialog},on:{"close":_vm.closeEditServiceTracking}}),_vm._v(" "),_c('delete-service-tracking-confirm-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showDeleteServiceTrackingConfirmDialog},on:{"close":_vm.closeDeleteServiceTracking}}),_vm._v(" "),_c('approve-service-tracking-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showApproveServiceTrackingDialog},on:{"close":_vm.closeApproveServiceTracking}})],1),_vm._v(" "),_c('div',{staticClass:"text-center button-center"},[_c('v-btn',{attrs:{"fab":"","color":"secondary","dark":"","bottom":"","center":""},on:{"click":_vm.openNewServiceTracking}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyApprovedServiceTracking_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073620d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyApprovedServiceTracking_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-073620d9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyApprovedServiceTracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073620d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyApprovedServiceTracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 60px)"},attrs:{"id":"myApprovedTrackings"}},[_c('v-list',{directives:[{name:"scroll",rawName:"v-scroll:#myApprovedTrackings",value:(_vm.onScroll),expression:"onScroll",arg:"#myApprovedTrackings"}],attrs:{"two-line":""}},[_vm._l((_vm.myTrackings),function(tracking,index){return [_c('v-list-item',{key:index},[_c('v-list-item-action',[_c('v-icon',{attrs:{"medium":""}},[_vm._v("check_circle_outline")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(tracking.customer.firstName)+" "+_vm._s(tracking.customer.lastName))]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"hidden-xs-and-down"},[_vm._v(_vm._s(tracking.customer.street)+", "+_vm._s(tracking.customer.city))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.getDate(tracking.startTime))+": "+_vm._s(_vm.getTime(tracking.startTime))+"-"+_vm._s(_vm.getTime(tracking.finishTime)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(tracking.service.name))])],1),_vm._v(" "),_c('v-list-item-action',{style:({'align-items':'center'})},[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditServiceTracking(tracking)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1),_vm._v(" "),(index + 1 < _vm.myTrackings.length)?_c('v-divider',{key:'divider-'+index}):_vm._e()]})],2)],1),_vm._v(" "),_c('data-loader'),_vm._v(" "),_c('edit-service-tracking-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showEditServiceTrackingDialog},on:{"close":_vm.closeEditServiceTracking}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllServiceTracking_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eca1850_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllServiceTracking_vue__ = __webpack_require__(493);
function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3eca1850"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllServiceTracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eca1850_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllServiceTracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 80px)"},attrs:{"id":"allTrackings","three-line":""}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#allTrackings",value:(_vm.onScroll),expression:"onScroll",arg:"#allTrackings"}],attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.allTrackings),function(monthedTrackings,monthIndex){return [_c('v-subheader',{key:'subheader-month-'+monthIndex,staticClass:".title"},[_vm._v("\n              "+_vm._s(_vm.mapYearMonth(monthedTrackings.month))+"\n            ")]),_vm._v(" "),_vm._l((monthedTrackings.userGroupedServiceTrackings),function(groupedTrackings,groupIndex){return [_c('v-subheader',{key:'subheader-' + monthIndex + '-' +    groupIndex,staticClass:".subheading"},[_vm._v("\n                "+_vm._s(_vm.getSubheader(groupedTrackings.usersServiceTracking))+"\n              ")]),_vm._v(" "),_vm._l((groupedTrackings.usersServiceTracking),function(tracking,index){return [_c('v-list-item',{key:monthIndex+'_'+groupIndex+'_'+index},[_c('v-list-item-avatar',[_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openApproveServiceTracking(tracking)}},model:{value:(tracking.approved),callback:function ($$v) {_vm.$set(tracking, "approved", $$v)},expression:"tracking.approved"}})],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(tracking.customer.firstName)+" "+_vm._s(tracking.customer.lastName)+"\n                    ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(tracking.customer.street)+", "+_vm._s(tracking.customer.zipCode)+"\n                      "+_vm._s(tracking.customer.lastName)+"\n                    ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.getDate(tracking.startTime))+":\n                      "+_vm._s(_vm.getTime(tracking.startTime))+"-"+_vm._s(_vm.getTime(tracking.finishTime))+"\n                    ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(tracking.service.name))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditServiceTracking(tracking)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteServiceTracking(tracking)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1),_vm._v(" "),(index +1 < groupedTrackings.usersServiceTracking.length)?_c('v-divider',{key:'divider-'+ groupIndex +'-'+ index,attrs:{"inset":true}}):_vm._e()]})]})]})],2)],1),_vm._v(" "),_c('data-loader'),_vm._v(" "),_c('new-tracking-dialog',{attrs:{"show":_vm.showNewServiceTrackingDialog},on:{"close":_vm.closeNewServiceTracking}}),_vm._v(" "),_c('edit-service-tracking-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showEditServiceTrackingDialog},on:{"close":_vm.closeEditServiceTracking}}),_vm._v(" "),_c('delete-service-tracking-confirm-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showDeleteServiceTrackingConfirmDialog},on:{"close":_vm.closeDeleteServiceTracking}}),_vm._v(" "),_c('approve-service-tracking-dialog',{attrs:{"service-tracking":_vm.selectedRecord,"show":_vm.showApproveServiceTrackingDialog},on:{"close":_vm.closeApproveServiceTracking}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3e75be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f3e75be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3e75be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[(!_vm.passwordChange)?_c('v-card',{staticClass:"elevation-12"},[_c('v-app-bar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Anmelden")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{ref:"email",attrs:{"name":"email","label":"E-Mail","id":"email","rules":_vm.mandatoryFieldRule,"prepend-icon":"person","type":"email","required":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSignin($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{ref:"password",attrs:{"name":"password","label":"Passwort","id":"password","rules":_vm.mandatoryFieldRule,"prepend-icon":"lock","type":"password","required":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSignin($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.loginFailed,"type":"error"}},[_vm._v("\n            Anmelden fehlgeschlagen!\n          ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","disabled":!_vm.valid,"loading":_vm.loading,"color":"primary"},on:{"click":_vm.onSignin}},[_vm._v("\n              Anmelden\n          ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.passwordChange)?_c('v-card',{staticClass:"elevation-12"},[_c('v-app-bar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Passwort ändern")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"name":"newPassword","label":"Neues Passwort","id":"newPassword","rules":_vm.passwordRules,"prepend-icon":"lock","type":"password","required":""},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","disabled":!_vm.valid,"loading":_vm.loading,"color":"primary"},on:{"click":_vm.onPasswordChanged}},[_vm._v("\n            Ändern\n          ")])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignOut_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d606c46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignOut_vue__ = __webpack_require__(499);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d606c46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d606c46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    Auf wieder sehen\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552d9c85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__(518);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552d9c85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewCustomerDialog_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed2d5392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewCustomerDialog_vue__ = __webpack_require__(511);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed2d5392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewCustomerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed2d5392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewCustomerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Neuer Kunde")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.sm),expression:"$vuetify.breakpoint.sm"}],attrs:{"text":"","disabled":!_vm.customerForm.valid},nativeOn:{"click":function($event){return _vm.createCustomer($event)}}},[_vm._v("\n          Kunde anlegen\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.customerForm.valid},nativeOn:{"click":function($event){return _vm.createCustomer($event)}}},[_c('v-icon',[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.customerForm.valid),callback:function ($$v) {_vm.$set(_vm.customerForm, "valid", $$v)},expression:"customerForm.valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Persönliche Daten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"E-Mail","required":""},model:{value:(_vm.customerForm.email),callback:function ($$v) {_vm.$set(_vm.customerForm, "email", $$v)},expression:"customerForm.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"label":"Anrede","items":_vm.salutations},model:{value:(_vm.customerForm.salutation),callback:function ($$v) {_vm.$set(_vm.customerForm, "salutation", $$v)},expression:"customerForm.salutation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Vorname"},model:{value:(_vm.customerForm.firstName),callback:function ($$v) {_vm.$set(_vm.customerForm, "firstName", $$v)},expression:"customerForm.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Nachname/Firmenname","rules":_vm.mandatoryFieldRule,"required":""},model:{value:(_vm.customerForm.lastName),callback:function ($$v) {_vm.$set(_vm.customerForm, "lastName", $$v)},expression:"customerForm.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Zusatz"},model:{value:(_vm.customerForm.addition),callback:function ($$v) {_vm.$set(_vm.customerForm, "addition", $$v)},expression:"customerForm.addition"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Straße","rules":_vm.mandatoryFieldRule},model:{value:(_vm.customerForm.street),callback:function ($$v) {_vm.$set(_vm.customerForm, "street", $$v)},expression:"customerForm.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Postleitzahl"},model:{value:(_vm.customerForm.zipCode),callback:function ($$v) {_vm.$set(_vm.customerForm, "zipCode", $$v)},expression:"customerForm.zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Stadt","rules":_vm.mandatoryFieldRule},model:{value:(_vm.customerForm.city),callback:function ($$v) {_vm.$set(_vm.customerForm, "city", $$v)},expression:"customerForm.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Telefon-Nummer","mask":"###########################"},model:{value:(_vm.customerForm.phoneNumber),callback:function ($$v) {_vm.$set(_vm.customerForm, "phoneNumber", $$v)},expression:"customerForm.phoneNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Gewerblicher Kunde","color":"primary"},model:{value:(_vm.customerForm.business),callback:function ($$v) {_vm.$set(_vm.customerForm, "business", $$v)},expression:"customerForm.business"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-switch',{attrs:{"label":"Mehrwertsteuer berechnen","color":"primary"},model:{value:(_vm.customerForm.calculateVat),callback:function ($$v) {_vm.$set(_vm.customerForm, "calculateVat", $$v)},expression:"customerForm.calculateVat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Anfahrtsberechnung")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-switch',{attrs:{"label":"Anfahrt berechnen","color":"primary"},model:{value:(_vm.customerForm.approachCharge),callback:function ($$v) {_vm.$set(_vm.customerForm, "approachCharge", $$v)},expression:"customerForm.approachCharge"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-currency-field',_vm._b({attrs:{"disabled":!_vm.customerForm.approachCharge,"label":"Betrag pro Anfahrten"},model:{value:(_vm.customerForm.approachChargeValue),callback:function ($$v) {_vm.$set(_vm.customerForm, "approachChargeValue", $$v)},expression:"customerForm.approachChargeValue"}},'v-currency-field',_vm.currencyConfig,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-switch',{attrs:{"disabled":!_vm.customerForm.approachCharge,"label":"Feste Anzahl an Fahrten","color":"primary"},model:{value:(_vm.customerForm.fixDrives),callback:function ($$v) {_vm.$set(_vm.customerForm, "fixDrives", $$v)},expression:"customerForm.fixDrives"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":!(_vm.customerForm.fixDrives && _vm.customerForm.approachCharge),"label":"Anzahl Anfahrten","type":"number"},model:{value:(_vm.customerForm.fixDrivesNumber),callback:function ($$v) {_vm.$set(_vm.customerForm, "fixDrivesNumber", $$v)},expression:"customerForm.fixDrivesNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Anmerkungen zum Kunden")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"solo":"","name":"instruction-input","auto-grow":""},model:{value:(_vm.customerForm.internalInfos),callback:function ($$v) {_vm.$set(_vm.customerForm, "internalInfos", $$v)},expression:"customerForm.internalInfos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Mitarbeiterhinweis")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"solo":"","name":"instruction-input","auto-grow":""},model:{value:(_vm.customerForm.infos),callback:function ($$v) {_vm.$set(_vm.customerForm, "infos", $$v)},expression:"customerForm.infos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Mitarbeiter mit Anfahrtspauschale")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.users,"chips":"","deletable-chips":"","item-value":_vm.userValue,"item-text":_vm.userText,"return-object":"","label":"Mitarbeiter eingeben","multiple":""},scopedSlots:_vm._u([{key:"append-item",fn:function(){return [_c('v-divider'),_vm._v(" "),_c('v-list-item',{attrs:{"ripple":""},on:{"click":_vm.loadNextEmployeePage}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Weitere Mitarbeiter laden")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.customerForm.fareUsers),callback:function ($$v) {_vm.$set(_vm.customerForm, "fareUsers", $$v)},expression:"customerForm.fareUsers"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Dienstleistungszuweisung")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.customerServiceDefinitions,"chips":"","deletable-chips":"","item-value":_vm.serviceValue,"item-text":_vm.serviceText,"return-object":"","required":"","label":"Dienstleistung suchen","multiple":""},model:{value:(_vm.customerForm.customerServiceDefinitions),callback:function ($$v) {_vm.$set(_vm.customerForm, "customerServiceDefinitions", $$v)},expression:"customerForm.customerServiceDefinitions"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.customerForm.customerServiceDefinitions,"hide-default-footer":""},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Dienstleistung bearbeiten")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Beschreibung"},model:{value:(_vm.editedItem.description),callback:function ($$v) {_vm.$set(_vm.editedItem, "description", $$v)},expression:"editedItem.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 1"},model:{value:(_vm.editedItem.extraLine1),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine1", $$v)},expression:"editedItem.extraLine1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 2"},model:{value:(_vm.editedItem.extraLine2),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine2", $$v)},expression:"editedItem.extraLine2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 3"},model:{value:(_vm.editedItem.extraLine3),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine3", $$v)},expression:"editedItem.extraLine3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.frequencies,"label":"Abrechnungsrhythmus"},model:{value:(_vm.editedItem.frequency),callback:function ($$v) {_vm.$set(_vm.editedItem, "frequency", $$v)},expression:"editedItem.frequency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Pauschale?","color":"primary"},model:{value:(_vm.editedItem.flatRate),callback:function ($$v) {_vm.$set(_vm.editedItem, "flatRate", $$v)},expression:"editedItem.flatRate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Pauschalbetrag"},model:{value:(_vm.editedItem.flatRateFee),callback:function ($$v) {_vm.$set(_vm.editedItem, "flatRateFee", $$v)},expression:"editedItem.flatRateFee"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.closeDefinitionDialog}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.saveDefinition}},[_vm._v("Speichern")])],1)],1)],1)]},proxy:true},{key:"item.frequency",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                  "+_vm._s(_vm.getFrequencyRowText(item.frequency))+"\n                ")]}},{key:"item.flatRate",fn:function(ref){
var item = ref.item;
return [(item.flatRate)?_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("\n                  check_circle\n                  ")]):_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("\n                  cancel\n                  ")])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.edit(item)}}},[_vm._v("\n                    edit\n                  ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.remove(item)}}},[_vm._v("\n                    delete\n                  ")])]}},{key:"no-data",fn:function(){return [_vm._v("\n                  Keine Auswahl\n                ")]},proxy:true}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.customerForm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.createCustomer($event)}}},[_vm._v("\n        Kunde anlegen\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCustomerDialog_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ef282c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCustomerDialog_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53ef282c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCustomerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ef282c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCustomerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Kunde bearbeiten")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.sm),expression:"$vuetify.breakpoint.sm"}],attrs:{"text":"","disabled":!_vm.customer.valid},nativeOn:{"click":function($event){return _vm.updateCustomer($event)}}},[_vm._v("\n          Kunde bearbeiten\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.customer.valid},nativeOn:{"click":function($event){return _vm.createCustomer($event)}}},[_c('v-icon',[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.customer.valid),callback:function ($$v) {_vm.$set(_vm.customer, "valid", $$v)},expression:"customer.valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Persönliche Daten")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"E-Mail","required":""},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"label":"Anrede","items":_vm.salutations},model:{value:(_vm.customer.salutation),callback:function ($$v) {_vm.$set(_vm.customer, "salutation", $$v)},expression:"customer.salutation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Vorname"},model:{value:(_vm.customer.firstName),callback:function ($$v) {_vm.$set(_vm.customer, "firstName", $$v)},expression:"customer.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Nachname/Firmenname","rules":_vm.mandatoryFieldRule,"required":""},model:{value:(_vm.customer.lastName),callback:function ($$v) {_vm.$set(_vm.customer, "lastName", $$v)},expression:"customer.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Zusatz"},model:{value:(_vm.customer.addition),callback:function ($$v) {_vm.$set(_vm.customer, "addition", $$v)},expression:"customer.addition"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Straße","rules":_vm.mandatoryFieldRule},model:{value:(_vm.customer.street),callback:function ($$v) {_vm.$set(_vm.customer, "street", $$v)},expression:"customer.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Postleitzahl"},model:{value:(_vm.customer.zipCode),callback:function ($$v) {_vm.$set(_vm.customer, "zipCode", $$v)},expression:"customer.zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Stadt","rules":_vm.mandatoryFieldRule},model:{value:(_vm.customer.city),callback:function ($$v) {_vm.$set(_vm.customer, "city", $$v)},expression:"customer.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Telefon-Nummer","mask":"###########################"},model:{value:(_vm.customer.phoneNumber),callback:function ($$v) {_vm.$set(_vm.customer, "phoneNumber", $$v)},expression:"customer.phoneNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Gewerblicher Kunde","color":"primary"},model:{value:(_vm.customer.business),callback:function ($$v) {_vm.$set(_vm.customer, "business", $$v)},expression:"customer.business"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-switch',{attrs:{"label":"Mehrwertsteuer berechnen","color":"primary"},model:{value:(_vm.customer.calculateVat),callback:function ($$v) {_vm.$set(_vm.customer, "calculateVat", $$v)},expression:"customer.calculateVat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Anfahrtsberechnung")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-switch',{attrs:{"label":"Anfahrt berechnen","color":"primary"},model:{value:(_vm.customer.approachCharge),callback:function ($$v) {_vm.$set(_vm.customer, "approachCharge", $$v)},expression:"customer.approachCharge"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-currency-field',_vm._b({attrs:{"disabled":!_vm.customer.approachCharge,"label":"Betrag pro Anfahrten"},model:{value:(_vm.customer.approachChargeValue),callback:function ($$v) {_vm.$set(_vm.customer, "approachChargeValue", $$v)},expression:"customer.approachChargeValue"}},'v-currency-field',_vm.currencyConfig,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-switch',{attrs:{"disabled":!_vm.customer.approachCharge,"label":"Feste Anzahl an Fahrten","color":"primary"},model:{value:(_vm.customer.fixDrives),callback:function ($$v) {_vm.$set(_vm.customer, "fixDrives", $$v)},expression:"customer.fixDrives"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":!(_vm.customer.fixDrives && _vm.customer.approachCharge),"label":"Anzahl Anfahrten","type":"number"},model:{value:(_vm.customer.fixDrivesNumber),callback:function ($$v) {_vm.$set(_vm.customer, "fixDrivesNumber", $$v)},expression:"customer.fixDrivesNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Anmerkungen zum Kunden")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"solo":"","name":"instruction-input","auto-grow":""},model:{value:(_vm.customer.internalInfos),callback:function ($$v) {_vm.$set(_vm.customer, "internalInfos", $$v)},expression:"customer.internalInfos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Mitarbeiterhinweis")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"solo":"","name":"instruction-input","auto-grow":""},model:{value:(_vm.customer.infos),callback:function ($$v) {_vm.$set(_vm.customer, "infos", $$v)},expression:"customer.infos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Mitarbeiter mit Anfahrtspauschale")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.users,"chips":"","deletable-chips":"","item-value":_vm.userValue,"item-text":_vm.userText,"return-object":"","label":"Mitarbeiter eingeben","multiple":""},nativeOn:{"input":function($event){return _vm.loadUsers($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"input-value":data.selected,"close":""},on:{"input":function($event){return _vm.removeUser(data.item)}}},[_vm._v("\n                    "+_vm._s(data.item.firstName)+" "+_vm._s(data.item.lastName)+" - "+_vm._s(data.item.street)+", "+_vm._s(data.item.city)+"\n                  ")])]}}]),model:{value:(_vm.customer.fareUsers),callback:function ($$v) {_vm.$set(_vm.customer, "fareUsers", $$v)},expression:"customer.fareUsers"}},[_vm._v(" "),void 0],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"title"},[_vm._v("Dienstleistungszuweisung")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.customerServiceDefinitions,"chips":"","deletable-chips":"","item-value":_vm.serviceValue,"item-text":_vm.serviceText,"return-object":"","required":"","label":"Dienstleistung suchen","multiple":""},model:{value:(_vm.customer.customerServiceDefinitions),callback:function ($$v) {_vm.$set(_vm.customer, "customerServiceDefinitions", $$v)},expression:"customer.customerServiceDefinitions"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.customer.customerServiceDefinitions,"hide-default-footer":""},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Dienstleistung bearbeiten")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Beschreibung"},model:{value:(_vm.editedItem.description),callback:function ($$v) {_vm.$set(_vm.editedItem, "description", $$v)},expression:"editedItem.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 1"},model:{value:(_vm.editedItem.extraLine1),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine1", $$v)},expression:"editedItem.extraLine1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 2"},model:{value:(_vm.editedItem.extraLine2),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine2", $$v)},expression:"editedItem.extraLine2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Extrazeile 3"},model:{value:(_vm.editedItem.extraLine3),callback:function ($$v) {_vm.$set(_vm.editedItem, "extraLine3", $$v)},expression:"editedItem.extraLine3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.frequencies,"label":"Abrechnungsrhythmus"},model:{value:(_vm.editedItem.frequency),callback:function ($$v) {_vm.$set(_vm.editedItem, "frequency", $$v)},expression:"editedItem.frequency"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Pauschale?","color":"primary"},model:{value:(_vm.editedItem.flatRate),callback:function ($$v) {_vm.$set(_vm.editedItem, "flatRate", $$v)},expression:"editedItem.flatRate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Pauschalbetrag"},model:{value:(_vm.editedItem.flatRateFee),callback:function ($$v) {_vm.$set(_vm.editedItem, "flatRateFee", $$v)},expression:"editedItem.flatRateFee"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.closeDefinitionDialog}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.saveDefinition}},[_vm._v("Speichern")])],1)],1)],1)]},proxy:true},{key:"item.frequency",fn:function(ref){
var item = ref.item;
return [_vm._v("\n                  "+_vm._s(_vm.getFrequencyRowText(item.frequency))+"\n                ")]}},{key:"item.flatRate",fn:function(ref){
var item = ref.item;
return [(item.flatRate)?_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("\n                  check_circle\n                  ")]):_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","dark":"","color":"primary"}},[_vm._v("\n                  cancel\n                  ")])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.edit(item)}}},[_vm._v("\n                    edit\n                  ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.remove(item)}}},[_vm._v("\n                    delete\n                  ")])]}},{key:"no-data",fn:function(){return [_vm._v("\n                  Keine Auswahl\n                ")]},proxy:true}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.updateCustomer($event)}}},[_vm._v("\n        Speichern\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteCustomerConfirmDialog_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2559f1aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteCustomerConfirmDialog_vue__ = __webpack_require__(517);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2559f1aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteCustomerConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2559f1aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteCustomerConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Kunde löschen")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("\n        Sie möchten den Kunden "),_c('b',[_vm._v(_vm._s(_vm.customer.name)+" ("+_vm._s(_vm.customer.email)+")")]),_vm._v(" wirklich löschen?\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":_vm.deleteCustomer}},[_vm._v("\n          Löschen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:".display-1",attrs:{"dark":""}},[_vm._v("Kunden")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{staticClass:"mx-1",attrs:{"label":"Suche nach Nach-/Firmenname","prepend-inner-icon":"search","solo":"","clearable":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"dark":"","color":"primary"},on:{"click":_vm.openNewDialog}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("person_add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"depressed":"","medium":"","dark":"","color":"primary"},on:{"click":_vm.openNewDialog}},[_vm._v("\n            Kunde Anlegen\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("person_add")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","fill-height":""}},[_c('v-flex',[_c('v-list',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 190px)"},attrs:{"id":"customerList","two-line":""}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#customerList",value:(_vm.onScroll),expression:"onScroll",arg:"#customerList"}],attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.customers),function(customer,index){return [(index % 2 === 1)?_c('v-list-item',{key:index,staticStyle:{"background-color":"#B3E5FC40"}},[_c('v-list-item-action',[(customer.business)?_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s('business'))]):_vm._e(),_vm._v(" "),(!customer.business)?_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s('person'))]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(customer.lastName)+" "+_vm._s(customer.firstName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(customer.street))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(customer.zipCode)+" "+_vm._s(customer.city))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditDialog(customer)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteDialog(customer)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1):_c('v-list-item',{key:index},[_c('v-list-item-action',[(customer.business)?_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s('business'))]):_vm._e(),_vm._v(" "),(!customer.business)?_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s('person'))]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(customer.lastName)+" "+_vm._s(customer.firstName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(customer.street))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(customer.zipCode)+" "+_vm._s(customer.city))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditDialog(customer)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteDialog(customer)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1),_vm._v(" "),(index + 1 < _vm.customers.length)?_c('v-divider',{key:'diviver-'+index}):_vm._e()]})],2)],1),_vm._v(" "),_c('new-customer-dialog',{attrs:{"show":_vm.showNewCustomerDialog},on:{"close":_vm.closeNewDialog}}),_vm._v(" "),_c('edit-customer-dialog',{attrs:{"customer":_vm.selectedCustomer,"show":_vm.showEditCustomerDialog},on:{"close":_vm.closeEditDialog}}),_vm._v(" "),_c('delete-customer-dialog',{attrs:{"customer":_vm.selectedCustomer,"show":_vm.showDeleteCustomerConfirmDialog},on:{"close":_vm.closeDeleteDialog}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c8dc68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(526);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c8dc68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewServiceDialog_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513bdca2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewServiceDialog_vue__ = __webpack_require__(521);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewServiceDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513bdca2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewServiceDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-sm-and-up",attrs:{"icon":"","dark":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Neue Dienstleistung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.serviceForm.valid},nativeOn:{"click":function($event){return _vm.createService($event)}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.serviceForm.valid),callback:function ($$v) {_vm.$set(_vm.serviceForm, "valid", $$v)},expression:"serviceForm.valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Name","rules":_vm.mandatoryFieldRule},model:{value:(_vm.serviceForm.name),callback:function ($$v) {_vm.$set(_vm.serviceForm, "name", $$v)},expression:"serviceForm.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"label":"Private Vergütung pro Stunde"},model:{value:(_vm.serviceForm.privateHourFee),callback:function ($$v) {_vm.$set(_vm.serviceForm, "privateHourFee", $$v)},expression:"serviceForm.privateHourFee"}},'v-currency-field',_vm.currencyConfig,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"label":"Gewerbliche Vergütung pro Stunde"},model:{value:(_vm.serviceForm.businessHourFee),callback:function ($$v) {_vm.$set(_vm.serviceForm, "businessHourFee", $$v)},expression:"serviceForm.businessHourFee"}},'v-currency-field',_vm.currencyConfig,false))],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-xs-only"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.serviceForm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.createService($event)}}},[_vm._v("\n        Dienstleistung anlegen\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditServiceDialog_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a986d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditServiceDialog_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditServiceDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a986d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditServiceDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.xs,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-sm-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dienstleistung bearbeiten")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.valid},nativeOn:{"click":function($event){return _vm.updateService($event)}}},[_c('v-icon',[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Name","rules":_vm.mandatoryFieldRule},model:{value:(_vm.service.name),callback:function ($$v) {_vm.$set(_vm.service, "name", $$v)},expression:"service.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"label":"Private Vergütung pro Stunde"},model:{value:(_vm.service.privateHourFee),callback:function ($$v) {_vm.$set(_vm.service, "privateHourFee", $$v)},expression:"service.privateHourFee"}},'v-currency-field',_vm.currencyConfig,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"label":"Gewerbliche Vergütung pro Stunde"},model:{value:(_vm.service.businessHourFee),callback:function ($$v) {_vm.$set(_vm.service, "businessHourFee", $$v)},expression:"service.businessHourFee"}},'v-currency-field',_vm.currencyConfig,false))],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-xs-only"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.updateService($event)}}},[_vm._v("\n        Speichern\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteServiceConfirmDialog_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797efabd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteServiceConfirmDialog_vue__ = __webpack_require__(525);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteServiceConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797efabd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteServiceConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Dienstleistung löschen")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("\n        Sie möchten die Dienstleistung "),_c('b',[_vm._v(_vm._s(_vm.service.name))]),_vm._v(" wirklich löschen?\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":_vm.deleteService}},[_vm._v("\n          Löschen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:".display-1",attrs:{"dark":""}},[_vm._v("Dienstleistungen")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{staticClass:"mx-1",attrs:{"label":"Suchen","prepend-inner-icon":"search","solo":"","clearable":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"dark":"","color":"primary"},on:{"click":_vm.openNewService}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("library_add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"depressed":"","medium":"","dark":"","color":"primary"},on:{"click":_vm.openNewService}},[_vm._v("\n            Dienstleistung Anlegen\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("library_add")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","fill-height":""}},[_c('v-flex',[_c('v-list',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 190px)"},attrs:{"id":"serviceList","two-line":""}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#serviceList",value:(_vm.onScroll),expression:"onScroll",arg:"#serviceList"}],attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.services),function(service,index){return [(index % 2 === 1)?_c('v-list-item',{key:service.name,staticStyle:{"background-color":"#B3E5FC40"}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("private Vergütung: "+_vm._s(_vm.toCurrency(service.privateHourFee))+" €")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("gewerbliche Vergütung: "+_vm._s(_vm.toCurrency(service.businessHourFee))+" €")])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditService(service)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteService(service)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1):_c('v-list-item',{key:service.name},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("private Vergütung: "+_vm._s(_vm.toCurrency(service.privateHourFee))+" €")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("gewerbliche Vergütung: "+_vm._s(_vm.toCurrency(service.businessHourFee))+" €")])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditService(service)}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteService(service)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1),_vm._v(" "),(index + 1 < _vm.services.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('data-loader'),_vm._v(" "),_c('new-service-dialog',{attrs:{"show":_vm.showNewServiceDialog},on:{"close":_vm.closeNewService}}),_vm._v(" "),_c('edit-service-dialog',{attrs:{"service":_vm.selectedService,"show":_vm.showEditServiceDialog},on:{"close":_vm.closeEditService}}),_vm._v(" "),_c('delete-service-dialog',{attrs:{"service":_vm.selectedService,"show":_vm.showDeleteServiceConfirmDialog},on:{"close":_vm.closeDeleteService}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b437be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__ = __webpack_require__(534);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b437be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUserDialog_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447a0211_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUserDialog_vue__ = __webpack_require__(529);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447a0211_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Neuer Mitarbeiter")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.sm),expression:"$vuetify.breakpoint.sm"}],attrs:{"dark":"","text":"","disabled":!_vm.userForm.valid},nativeOn:{"click":function($event){return _vm.createUser($event)}}},[_vm._v("\n          Mitarbeiter anlegen\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"dark":"","icon":"","disabled":!_vm.userForm.valid},nativeOn:{"click":function($event){return _vm.createUser($event)}}},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.smAndDown),expression:"$vuetify.breakpoint.smAndDown"}]},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"form",model:{value:(_vm.userForm.valid),callback:function ($$v) {_vm.$set(_vm.userForm, "valid", $$v)},expression:"userForm.valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":_vm.emailRules},model:{value:(_vm.userForm.email),callback:function ($$v) {_vm.$set(_vm.userForm, "email", $$v)},expression:"userForm.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.userForm.showPassword ? 'visibility_off' : 'visibility',"type":_vm.userForm.showPassword ? 'text' : 'password',"label":"Initiales Passwort","rules":_vm.passwordRules},on:{"click:append":function($event){_vm.userForm.showPassword = !(_vm.userForm.showPassword)}},model:{value:(_vm.userForm.password),callback:function ($$v) {_vm.$set(_vm.userForm, "password", $$v)},expression:"userForm.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.roles,"label":"Rollen auswählen","rules":_vm.mandatoryFieldRule,"item-text":"name","item-value":"id","return-object":"","required":""},model:{value:(_vm.userForm.role),callback:function ($$v) {_vm.$set(_vm.userForm, "role", $$v)},expression:"userForm.role"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.customers,"chips":"","deletable-chips":"","item-value":_vm.customerValue,"item-text":_vm.customerText,"return-object":"","label":"Kunden eingeben","multiple":""},scopedSlots:_vm._u([{key:"append-item",fn:function(){return [_c('v-divider'),_vm._v(" "),_c('v-list-item',{attrs:{"ripple":""},on:{"click":_vm.loadNextCustomerPage}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Weitere Kunden laden")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.userForm.customers),callback:function ($$v) {_vm.$set(_vm.userForm, "customers", $$v)},expression:"userForm.customers"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Vorname","rules":_vm.mandatoryFieldRule},model:{value:(_vm.userForm.firstName),callback:function ($$v) {_vm.$set(_vm.userForm, "firstName", $$v)},expression:"userForm.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Nachname","rules":_vm.mandatoryFieldRule},model:{value:(_vm.userForm.lastName),callback:function ($$v) {_vm.$set(_vm.userForm, "lastName", $$v)},expression:"userForm.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Straße","rules":_vm.mandatoryFieldRule},model:{value:(_vm.userForm.street),callback:function ($$v) {_vm.$set(_vm.userForm, "street", $$v)},expression:"userForm.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Postleitzahl","rules":_vm.zipCodeRules},model:{value:(_vm.userForm.zipCode),callback:function ($$v) {_vm.$set(_vm.userForm, "zipCode", $$v)},expression:"userForm.zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Stadt","rules":_vm.mandatoryFieldRule},model:{value:(_vm.userForm.city),callback:function ($$v) {_vm.$set(_vm.userForm, "city", $$v)},expression:"userForm.city"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.userForm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.createUser($event)}}},[_vm._v("\n        Mitarbeiter anlegen\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserDialog_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bab34696_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserDialog_vue__ = __webpack_require__(531);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bab34696_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.smAndDown,"persistent":"","transition":"dialog-bottom-transition","scrollable":"","max-width":"80%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"max-height":"65px"},attrs:{"dark":"","color":"primary"}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Mitarbeiter bearbeiten")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.sm),expression:"$vuetify.breakpoint.sm"}],attrs:{"text":"","disabled":!_vm.valid},nativeOn:{"click":function($event){return _vm.updateUser($event)}}},[_vm._v("\n          Mitarbeiter bearbeiten\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xs),expression:"$vuetify.breakpoint.xs"}],attrs:{"icon":"","disabled":!_vm.valid,"dark":""},nativeOn:{"click":function($event){return _vm.updateUser($event)}}},[_c('v-icon',[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"E-Mail","rules":_vm.emailRules},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-checkbox',{attrs:{"label":"Passwort","color":"primary"},model:{value:(_vm.showPwField),callback:function ($$v) {_vm.showPwField=$$v},expression:"showPwField"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPwField),expression:"showPwField"}],attrs:{"append-icon":_vm.showPassword ? 'visibility_off' : 'visibility',"type":_vm.showPassword ? 'text' : 'password',"label":"Passwort","rules":_vm.passwordRules},on:{"click:append":function($event){_vm.showPassword = !(_vm.showPassword)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.roles,"label":"Rollen auswählen","rules":_vm.mandatoryFieldRule,"item-text":"name","item-value":"id","return-object":""},model:{value:(_vm.user.role),callback:function ($$v) {_vm.$set(_vm.user, "role", $$v)},expression:"user.role"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.allCustomers,"chips":"","deletable-chips":"","item-value":_vm.customerValue,"item-text":_vm.customerText,"return-object":"","label":"Kunden eingeben","multiple":""},scopedSlots:_vm._u([{key:"append-item",fn:function(){return [_c('v-divider'),_vm._v(" "),_c('v-list-item',{attrs:{"ripple":""},on:{"click":_vm.loadNextCustomerPage}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Weitere Kunden laden")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})]},proxy:true}]),model:{value:(_vm.user.customers),callback:function ($$v) {_vm.$set(_vm.user, "customers", $$v)},expression:"user.customers"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Vorname","rules":_vm.mandatoryFieldRule},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Nachname","rules":_vm.mandatoryFieldRule},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Straße","rules":_vm.mandatoryFieldRule},model:{value:(_vm.user.street),callback:function ($$v) {_vm.$set(_vm.user, "street", $$v)},expression:"user.street"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":"Postleitzahl","rules":_vm.zipCodeRules},model:{value:(_vm.user.zipCode),callback:function ($$v) {_vm.$set(_vm.user, "zipCode", $$v)},expression:"user.zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"Stadt","rules":_vm.mandatoryFieldRule},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"hidden-sm-and-down"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"loading":_vm.loading,"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.updateUser($event)}}},[_vm._v("\n        Speichern\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUserConfirmDialog_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00cecbd2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUserConfirmDialog_vue__ = __webpack_require__(533);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUserConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00cecbd2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUserConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Mitarbeiter löschen")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("\n        Sie möchten den Mitarbeiter "),_c('b',[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName)+" ("+_vm._s(_vm.user.email)+")")]),_vm._v(" wirklich löschen?\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":_vm.deleteUser}},[_vm._v("\n          Löschen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:".display-1",attrs:{"dark":""}},[_vm._v("Mitarbeiter")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{staticClass:"mx-1",attrs:{"label":"Suche nach Vornamen","prepend-inner-icon":"search","solo":"","clearable":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"dark":"","color":"primary"},on:{"click":_vm.openNewUserDialog}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("person_add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"depressed":"","medium":"","dark":"","color":"primary"},on:{"click":_vm.openNewUserDialog}},[_vm._v("\n            Mitarbeiter Anlegen\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("person_add")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","fill-height":""}},[_c('v-flex',[_c('v-list',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 190px)"},attrs:{"id":"userList","two-line":""}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#userList",value:(_vm.onScroll),expression:"onScroll",arg:"#userList"}],attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.users),function(user,index){return [(index % 2 === 1)?_c('v-list-item',{key:index,staticStyle:{"background-color":"#B3E5FC40"}},[_c('v-list-item-action',[(user.role.name==='ADMIN')?_c('v-icon',[_vm._v("school")]):_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Kunden: "+_vm._s(user.customers.length))])],1),_vm._v(" "),(user.id > 1)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditUser(user)}}},[_c('v-icon',[_vm._v("edit")])],1)],1):_vm._e(),_vm._v(" "),(user.id > 1)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteUser(user)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()],1):_c('v-list-item',{key:index},[_c('v-list-item-action',[(user.role.name==='ADMIN')?_c('v-icon',[_vm._v("school")]):_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Kunden: "+_vm._s(user.customers.length))])],1),_vm._v(" "),(user.id > 1)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openEditUser(user)}}},[_c('v-icon',[_vm._v("edit")])],1)],1):_vm._e(),_vm._v(" "),(user.id > 1)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.openDeleteUser(user)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 < _vm.users.length)?_c('v-divider',{key:'divider-'+index}):_vm._e()]})],2)],1),_vm._v(" "),_c('new-user-dialog',{attrs:{"show":_vm.showNewUserDialog},on:{"close":_vm.closeNewUserDialog}}),_vm._v(" "),_c('edit-user-dialog',{attrs:{"user":_vm.selectedUser,"show":_vm.showEditUserDialog},on:{"close":_vm.closeEditUserDialog}}),_vm._v(" "),_c('delete-user-dialog',{attrs:{"user":_vm.selectedUser,"show":_vm.showDeleteUserConfirmDialog},on:{"close":_vm.closeDeleteUserDialog}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229095e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-229095e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229095e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeInvoiceList_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3d1862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeInvoiceList_vue__ = __webpack_require__(539);
function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa3d1862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmployeeInvoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3d1862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmployeeInvoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 538:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"button-padding",attrs:{"row":"","justify-end":""}},[_c('div',[_c('v-btn',{attrs:{"color":"primary","depressed":"","large":"","disabled":!_vm.isInvoiceSelected(),"loading":_vm.loading},on:{"click":function($event){return _vm.bulkDownload()}}},[_vm._v("Herunterladen")])],1)]),_vm._v(" "),_c('v-layout',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 192px)"},attrs:{"column":"","fill-height":"","id":"allEmployeeInvoices"}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#allEmployeeInvoices",value:(_vm.onScroll),expression:"onScroll",arg:"#allEmployeeInvoices"}],attrs:{"align":"center","justify":"center"}},_vm._l((_vm.monthlyGroupInvoices),function(monthGroup,index){return _c('v-list',{key:monthGroup.month},[_c('v-flex',{staticClass:"month-header"},[_c('v-checkbox',{attrs:{"color":"primary"},on:{"change":function($event){return _vm.monthSelectionChanged(monthGroup.month, $event)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"primary--text month-header-text"},[_vm._v(_vm._s(_vm.mapYearMonth(monthGroup.month)))])])]},proxy:true}],null,true),model:{value:(_vm.selectedMonths[index]),callback:function ($$v) {_vm.$set(_vm.selectedMonths, index, $$v)},expression:"selectedMonths[index]"}})],1),_vm._v(" "),_vm._l((monthGroup.invoices),function(invoice,invoiceIndex){return [(invoiceIndex % 2 === 1)?_c('v-list-item',{key:invoice.id,staticStyle:{"background-color":"#B3E5FC40"}},[_c('v-checkbox',{attrs:{"color":"black"},on:{"change":function($event){return _vm.invoiceSelectionChanged(invoice, index, $event)}},model:{value:(_vm.selectedInvoices[invoice.id]),callback:function ($$v) {_vm.$set(_vm.selectedInvoices, invoice.id, $$v)},expression:"selectedInvoices[invoice.id]"}}),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.listItemLabel1(invoice)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.listItemLabel2(invoice)))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.openEmployeeInvoice(invoice.id)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("receipt")])],1)],1)],1):_c('v-list-item',{key:invoice.id},[_c('v-checkbox',{attrs:{"color":"black"},on:{"change":function($event){return _vm.invoiceSelectionChanged(invoice, index, $event)}},model:{value:(_vm.selectedInvoices[invoice.id]),callback:function ($$v) {_vm.$set(_vm.selectedInvoices, invoice.id, $$v)},expression:"selectedInvoices[invoice.id]"}}),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.listItemLabel1(invoice)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.listItemLabel2(invoice)))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.openEmployeeInvoice(invoice.id)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("receipt")])],1)],1)],1),_vm._v(" "),(invoiceIndex + 1 < monthGroup.invoices.length)?_c('v-divider',{key:monthGroup+'-divider-'+invoiceIndex}):_vm._e()]})],2)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerInvoiceList_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568e5d44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerInvoiceList_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-568e5d44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerInvoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568e5d44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerInvoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseInvoiceConfirmDialog_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293f2ee3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseInvoiceConfirmDialog_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-293f2ee3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseInvoiceConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293f2ee3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseInvoiceConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Abrechnung(en) veröffentlichen")])],1),_vm._v(" "),_c('v-card',[(_vm.yearMonth)?_c('v-card-text',[_vm._v("\n        Möchten sie die Abrechnungen des Monats "),_c('b',[_vm._v(_vm._s(_vm.mapYearMonth(_vm.yearMonth)))]),_vm._v(" wirklich veröffentlichen?\n      ")]):(_vm.invoices && _vm.invoices.length > 1)?_c('v-card-text',[_vm._v("\n        Möchten sie die "),_c('b',[_vm._v(_vm._s(_vm.invoices.length))]),_vm._v(" Abrechnungen wirklich veröffentlichen?\n      ")]):(_vm.invoice && _vm.invoice.type === 'CUSTOMER_INVOICE')?_c('v-card-text',[_vm._v("\n        Sie möchten die Abrechnung für den Kunden "),_c('b',[_vm._v(_vm._s(_vm.invoice.customer.lastName)+" "+_vm._s(_vm.invoice.customer.firstName))]),_vm._v("\n        wirklich veröffentlichen?\n      ")]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","text":""},on:{"click":_vm.release}},[_vm._v("\n          Veröffentlichen\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendInvoiceConfirmDialogue_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaca886_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendInvoiceConfirmDialogue_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eaca886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendInvoiceConfirmDialogue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaca886_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendInvoiceConfirmDialogue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Abrechnung(en) versenden")])],1),_vm._v(" "),_c('v-card',[(_vm.yearMonth)?_c('v-card-text',{attrs:{"primary-title":""}},[_c('p',[_vm._v("Möchten sie die Abrechnungen des Monats "),_c('b',[_vm._v(_vm._s(_vm.mapYearMonth(_vm.yearMonth)))]),_vm._v(" wirklich versenden?")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("warning")]),_vm._v("Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!\n      ")],1):(_vm.invoices && _vm.invoices.length > 1)?_c('v-card-text',{attrs:{"primary-title":""}},[_c('p',[_vm._v("Möchten sie die "),_c('b',[_vm._v(_vm._s(_vm.invoices.length))]),_vm._v(" Abrechnungen wirklich versenden?")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("warning")]),_vm._v("Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!\n      ")],1):(_vm.invoice && _vm.invoice.type === 'CUSTOMER_INVOICE')?_c('v-card-text',{attrs:{"primary-title":""}},[_c('p',[_vm._v("Sie möchten die Abrechnung für den Kunden "),_c('b',[_vm._v(_vm._s(_vm.invoice.customer.lastName)+" "+_vm._s(_vm.invoice.customer.firstName))]),_vm._v("\n        wirklich versenden?")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("warning")]),_vm._v("Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!\n      ")],1):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n          Abbrechen\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","text":""},on:{"click":_vm.send}},[_vm._v("\n          Versenden\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"button-padding",attrs:{"row":"","justify-end":""}},[_c('div',[_c('v-btn',{attrs:{"color":"primary","depressed":"","large":"","disabled":!_vm.isInvoiceSelected(),"loading":_vm.loading},on:{"click":function($event){return _vm.bulkDownload()}}},[_vm._v("\n        Herunterladen\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","depressed":"","large":"","disabled":!_vm.isInvoiceSelectedReleased()},on:{"click":function($event){return _vm.bulkRelease()}}},[_vm._v("\n        Veröffentlichen\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","depressed":"","large":"","disabled":!_vm.isInvoiceSendable()},on:{"click":function($event){return _vm.bulkSend()}}},[_vm._v("\n        E-Mail versenden\n      ")]),_vm._v(" "),_c('v-flex')],1)]),_vm._v(" "),_c('v-layout',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"calc(100vh - 192px)"},attrs:{"column":"","fill-height":"","id":"allCustomerInvoices"}},[_c('v-flex',{directives:[{name:"scroll",rawName:"v-scroll:#allCustomerInvoices",value:(_vm.onScroll),expression:"onScroll",arg:"#allCustomerInvoices"}],attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.monthlyGroupInvoices),function(monthGroup,index){return _c('v-list',{key:monthGroup.month},[(monthGroup.month)?_c('v-subheader',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"change":function($event){return _vm.monthSelectionChanged(monthGroup.month, $event)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"primary--text month-header-text"},[_vm._v(_vm._s(_vm.mapYearMonth(monthGroup.month)))])])]},proxy:true}],null,true),model:{value:(_vm.selectedMonths[index]),callback:function ($$v) {_vm.$set(_vm.selectedMonths, index, $$v)},expression:"selectedMonths[index]"}}),_vm._v(" "),_c('v-flex'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.openTurnoverPdf(monthGroup.month)}}},[_vm._v("Umsatz")])],1):_vm._e(),_vm._v(" "),_vm._l((monthGroup.invoices),function(invoice,invoiceIndex){return [(invoiceIndex % 2 === 1)?_c('v-list-item',{key:invoice.id,staticStyle:{"background-color":"#B3E5FC40"}},[_c('v-checkbox',{attrs:{"color":"black"},on:{"change":function($event){return _vm.invoiceSelectionChanged(invoice, index, $event)}},model:{value:(_vm.selectedInvoices[invoice.id]),callback:function ($$v) {_vm.$set(_vm.selectedInvoices, invoice.id, $$v)},expression:"selectedInvoices[invoice.id]"}}),_vm._v(" "),_c('v-list-item-icon',[(invoice.released)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("lock")]):_c('v-icon',[_vm._v("lock_open")])],1),_vm._v(" "),_c('v-list-item-icon',[(_vm.isMailDelivered(invoice))?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")]):_vm._e(),_vm._v(" "),(_vm.isMailNotDelivered(invoice))?_c('v-icon',[_vm._v("mail")]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.listItemLabel1(invoice)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.listItemLabel2(invoice)))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.openCustomerInvoice(invoice.id)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("receipt")])],1)],1),_vm._v(" "),(!invoice.released)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.releaseInvoice(invoice)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("publish")])],1)],1):_vm._e(),_vm._v(" "),(invoice.released)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.sendInvoice(invoice)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("forward_to_inbox")])],1)],1):_vm._e()],1):_c('v-list-item',{key:invoice.id},[_c('v-checkbox',{attrs:{"color":"black"},on:{"change":function($event){return _vm.invoiceSelectionChanged(invoice, index, $event)}},model:{value:(_vm.selectedInvoices[invoice.id]),callback:function ($$v) {_vm.$set(_vm.selectedInvoices, invoice.id, $$v)},expression:"selectedInvoices[invoice.id]"}}),_vm._v(" "),_c('v-list-item-icon',[(invoice.released)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("lock")]):_c('v-icon',[_vm._v("lock_open")])],1),_vm._v(" "),_c('v-list-item-icon',[(_vm.isMailDelivered(invoice))?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")]):_vm._e(),_vm._v(" "),(_vm.isMailNotDelivered(invoice))?_c('v-icon',[_vm._v("mail")]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.listItemLabel1(invoice)))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.listItemLabel2(invoice)))])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.openCustomerInvoice(invoice.id)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("receipt")])],1)],1),_vm._v(" "),(!invoice.released)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.releaseInvoice(invoice)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("publish")])],1)],1):_vm._e(),_vm._v(" "),(invoice.released)?_c('v-list-item-action',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":_vm.isRowDisabled(invoice.id)},on:{"click":function($event){return _vm.sendInvoice(invoice)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("forward_to_inbox")])],1)],1):_vm._e()],1),_vm._v(" "),(invoiceIndex + 1 < monthGroup.invoices.length)?_c('v-divider',{key:monthGroup+'-divider-'+invoiceIndex}):_vm._e()]})],2)}),_vm._v(" "),_c('release-invoice-dialog',{attrs:{"invoice":_vm.selectedInvoice,"invoices":_vm.selectedInvoicesToRelease,"yearMonth":_vm.selectedMonth,"show":_vm.showReleaseInvoiceDialog},on:{"close":_vm.closeReleaseInvoiceDialog,"cancel":_vm.closeReleaseInvoiceDialogAndRetainData}}),_vm._v(" "),_c('send-invoice-dialog',{attrs:{"invoice":_vm.selectedInvoice,"invoices":_vm.selectedInvoicesToSend,"yearMonth":_vm.selectedMonth,"show":_vm.showSendInvoiceDialog},on:{"close":_vm.closeSendInvoiceDialog,"cancel":_vm.closeSendInvoiceDialogAndRetainData}})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","fill-height":""}},[_c('v-tabs',{attrs:{"centered":"","grow":"","icons-and-text":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._v(" "),_c('v-tab',{key:'employeeTab',staticClass:"primary--text"},[_vm._v("\n      Mitarbeiter\n      "),_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-tab',{key:'customerTab',staticClass:"primary--text"},[_vm._v("\n      Kunden\n      "),_c('v-icon',[_vm._v("group")])],1),_vm._v(" "),_c('v-tab-item',{key:'employeeTab'},[_c('employee-invoice-list')],1),_vm._v(" "),_c('v-tab-item',{key:'customerTab'},[_c('customer-invoice-list')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(146);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user;

  if (currentUser !== null && currentUser !== undefined && to.path !== '/signIn') {
    if (to.path === '/') {
      if (currentUser.role.toUpperCase() === 'ADMIN') {
        next({ path: '/allTracking' });
      } else {
        next({ path: '/myTracking' });
      }
    } else if (to.meta.roles.includes(currentUser.role.toUpperCase())) {
      next();
    }
  } else {
    var loginPath = window.location.pathname;
    if (loginPath !== '/signIn') {
      next({ name: 'signIn', query: { from: loginPath } });
    } else {
      next(false);
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389219b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(553);
function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-389219b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389219b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","height":"110","width":"110"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-card',{attrs:{"color":"primary","dark":"","height":"110","width":"110"}},[_c('v-card-text',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":70,"width":7}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_service__ = __webpack_require__(351);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__user_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_service__ = __webpack_require__(480);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__service_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_service__ = __webpack_require__(481);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__customer_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_tracking_service__ = __webpack_require__(482);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__service_tracking_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__invoice_service__ = __webpack_require__(483);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__invoice_service__["a"]; });






/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
  theme: {
    themes: {
      light: {
        primary: '#2297D0',
        accent: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.lightBlue.accent1,
        secondary: '#D05B22',
        info: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.blue.lighten1,
        warning: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.amber.darken2,
        error: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.red.accent4,
        success: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.green.lighten2
      },
      dark: {
        primary: '#2297D0',
        accent: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.lightBlue.accent1,
        secondary: '#D05B22',
        info: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.blue.lighten1,
        warning: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.amber.darken2,
        error: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.red.accent4,
        success: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.green.lighten2
      }
    }
  },
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  }
}));

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_header__ = __webpack_require__(354);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__auth_header__["a"]; });


/***/ }),

/***/ 834:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[336]);


// WEBPACK FOOTER //
// static/js/app.10fa5f1f0fc12d72a13f.js